import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../shared/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MarketAccounting } from '../../../entities/market-accounting.model';
import { BackofficeMarketAccountingEntry } from '../../../entities/backoffice-market-accounting-entry.model';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { JhiLanguageService } from 'ng-jhipster';
import { RoutingDataService } from '../../../shared/services/routing-data.service';
import { MarketDateComment, MarketDateCommentImage, MarketDateCommentImages } from '../../../entities/market-date-comment.model';
import {
  Booth,
  Boothfee,
  Contact,
  ContractType,
  EnergyPriceType,
  Marketdate,
  MarketdateStatusEnum,
  MarketmasterStatusEnum,
  Salesunit
} from '../../../entities';
import { Observable } from 'rxjs/Observable';
import { MarketAccountingEntry, MarketAccountingEntryType } from '../../../entities/market-accounting-entry.model';
import { MarketdateStatus, MarketStatus } from '../../../entities/marketdate-status.model';
import { AccountService, Principal } from '../../../shared';
import * as moment from 'moment';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { Message, MessageActionType, MessageType } from '../../../entities/message.model';
import { OpenPayment } from '../../../entities/open-payment.model';
import { MarketdateMeterreading, Origin, TimestampType } from '../../../entities/marketdate-meterreading.model';
import { GeoEntity } from '../../../entities/geo-entity.model';
import { OsmNominatimService } from '../../../shared/services/osm-nominatim.service';
import { Discount, DiscountType } from '../../../entities/discount.model';
import { WinterService } from '../../../shared/services/winter.service';
import { LocalStorageService } from 'ng2-webstorage';
import { Weather } from '../../../entities/weather.model';
import { DatePipe, DecimalPipe } from '@angular/common';
import { User } from 'app/entities/user.model';
import { Additionalflat } from 'app/entities/additionalflat.model';
import { Energyflat } from 'app/entities/energyflat.model';
import { MassSmsComponent } from '../../../shared/mass-sms/mass-sms.component';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { ContactStatus } from 'app/entities/contact.model';
import { deserialize } from 'json-typescript-mapper';
import { isNumber } from '@ng-bootstrap/ng-bootstrap/util/util';
import { Electricmeter } from 'app/entities/electricmeter.model';
import { isUndefined } from 'util';
import { CommentType } from 'app/entities/marketdate-comment.model';
import { AssortmentService } from '../../../shared/services/assortment.service';
import { MailComposerComponent } from '../../../shared/mail-composer/mail-composer.component';
import { ImageCarouselComponent } from '../../../shared/image-carousel/image-carousel.component';
import { SalesunitAssortmentCheck } from 'app/entities/salesunit.model';
import { NEW_IMAGE_UPLOAD, PLAUSIBLE_ENERGY_CONSUMPTION_SQM, PLAUSIBLE_ENERGY_CONSUMPTION_SU, TRAINING } from '../../../app.constants';
import { ElectricMeter } from 'app/entities/electric-meter.model';
import { ControlPosition, GoogleMap, MapOptions, ZoomControlStyle } from '@agm/core/services/google-maps-types';
import { FileService } from 'app/shared/services/file.service';
import { ContractHistory } from 'app/entities/contract-history.model';
import { ContractInterval } from '../../../entities/contract-interval.model';
import { Log } from 'app/entities/log.model';
import { plainToClass } from 'class-transformer';

declare var ol: any;
declare var google: any;

class DiscountOption {
  label: string;
  value: number;
}
class MerchantModifications {
  [key: number]: string[];
}
enum ApiStatus {
  Error = -1,
  NotLoaded = 0,
  Loading = 1,
  Loaded = 2
}

@Component({
  selector: 'app-market-detail',
  templateUrl: './market-detail.component.html',
  styleUrls: ['./market-detail.component.scss']
})
export class MarketDetailComponent implements OnInit, AfterViewInit {

  @ViewChild(DatatableComponent) marketAccountingEntryTable: DatatableComponent;
  @ViewChild('imageModal') private imageModal;
  @ViewChild('paymentModal') private paymentModal;
  @ViewChild('mapModal') private mapModal;
  @ViewChild('compensationModal') private compensationModal;
  @ViewChild('merchantDetailModal') private merchantDetailModal;
  @ViewChild('weatherModal') private weatherModal;
  @ViewChild('removeBranchNoteModal') private removeBranchNoteModal;
  @ViewChild('canvasEl') canvasEl: ElementRef;
  @ViewChild('closeMarketModal') closeMarketModal;
  @ViewChild('cannotCloseMarketModal') cannotCloseMarketModal;
  @ViewChild('errorMarketMasterStatusModal') errorMarketMasterStatusModal;
  @ViewChild('successMarketMasterStatusModal') successMarketMasterStatusModal;
  @ViewChild('confirmMerchantSearchModal') confirmMerchantSearchModal;
  @ViewChild('editMarketdateMeterreadingModal') editMarketdateMeterreadingModal;

  private context: CanvasRenderingContext2D;

  map: any;
  zoom = 16;
  osmNominatim: any;

  loadingIndicator = true;
  loadingOverlay: boolean;
  confirmationDisabled = true;
  marketAccounting: MarketAccounting;
  marketDate: Marketdate;
  marketDateIsInPast: boolean;
  filteredMarketAccountingEntries: BackofficeMarketAccountingEntry[];
  presentBooths: number;
  presentBoothsWithEnergyCosts: number;
  totalSqm = 0;
  totalSoldSqm = 0;
  totalSqmOfBoothsWithEnergyCosts = 0;
  extendedAssortmentSqm = 0;

  halfOrFullDay: 'halfDay' | 'fullDay';
  user: User;

  imagesWithCaptions: string[];

  plausibleConsumptionPerSalesunitLimit = PLAUSIBLE_ENERGY_CONSUMPTION_SU;

  plausibleConsumptionPerSquaremeter = PLAUSIBLE_ENERGY_CONSUMPTION_SQM;

  parentUrl: string;

  private modalRef: any = null;
  modalEntry: BackofficeMarketAccountingEntry;
  correctionNotice: string;
  imageModalRef: NgbModalRef = null;
  paymentModalRef: NgbModalRef = null;
  mapModalRef: NgbModalRef = null;
  public modalTitle = null;
  public modalImages = [];
  public modalImageIndex = 0;
  public modalImageDates = null;
  public selectedRow: BackofficeMarketAccountingEntry;
  public EnergyPriceType = EnergyPriceType;
  public marketingFeeTemp = 0;
  openingDuration: number;

  possibleTempMarketMasters: Contact[];

  marketMasterAccountingsSum = {
    boothTotalSum: 0,
    expenseTotalSum: 0,
    totalSum: 0
  };
  marketMasterExpenses = [];
  hasMarketMasterChanges = false;

  marketDateId = 0;

  tempInterimsMarketmasters: Contact[];
  rowDetailViewed = [];
  filteredMarketAccountingEntriesSorting = [{prop: 'updatedAt', dir: 'asc'}];

  marketMasterAccountings = [];

  cancelStatus: {value: MarketStatus, label: string, selected: boolean} [];
  cancelMarketReason: string;
  cancelMarketStatus: MarketStatus;

  manualSettlementMarketReason: string;

  confirmMarketReason: string;

  canChangeMarketMaser = false;

  selectedMerchant: BackofficeMarketAccountingEntry;
  selectedMerchantContractHistory: ContractHistory;
  selectedMerchantSalesunitAssortmentChecks: Array<SalesunitAssortmentCheck>;
  selectedMerchantContractIntervals: ContractInterval[];
  merchantLastContact: Contact;
  selectedElectricmeter: any;

  boothFee: Boothfee;
  boothFeeContract: Boothfee;
  boothFeeSqmPrice = 0;

  currentMarketStatus: MarketdateStatus;
  marketStatusOpen: MarketdateStatus;
  marketStatusClosed: MarketdateStatus;
  MarketStatus = MarketStatus;

  modifiedByContact: Contact;
  closedByContact: Contact;

  messages: Message[];
  messagesPages = [];
  messagesCounters: Number[];
  depositCounters: Number[];
  deposits: Message[];
  newMessage: Message;
  messageToEdit: Message;
  selectedMessage: Message | MarketDateComment;
  selectedMailLog: Log;
  messagesPage = 0;
  messagesPageSize = 20;
  messagesLoading = false;
  depositsLoading = false;
  depositsPage = 0;
  depositsPageSize = 10;
  MessageActionType = MessageActionType;

  branchNotes: Message[];
  newBranchNote: Message;
  branchNoteToEdit: Message;
  branchNoteToDelete: Message;

  openPayments: OpenPayment[];

  account: Account;

  countOfUnreadMessages: number;

  marketdateMeterreadingToEdit: MarketdateMeterreading;
  marketdateMeterreadingToEditValue: number;

  openPaymentToClear: OpenPayment;
  tempOpenPaymentComment: string;

  assortment: {name: string, value: string}[];
  assortmentExtended: {name: string, value: string}[];

  mapData: {
    geoEntity: GeoEntity,
    addressLine: {}
  };

  discountOptions: {
    single: DiscountOption[];
    periodic: DiscountOption[];
    socialorganization: DiscountOption[];
  };

  selectedMerchantDiscount: Discount;
  selectedMerchantVisits: string[];
  showDiscountVisitHint: boolean;

  DiscountType = DiscountType;

  discountEdit: boolean;

  discountDurationOptions: DiscountOption[];
  selectedMerchantDiscountDuration: number;

  winter: boolean;

  selectedMarketdateStatus: MarketdateStatus;

  merchantModifications: MerchantModifications;

  marketInfoActiveTab = 'market';

  additionalFlat: Additionalflat;
  additionalFlatContract: Additionalflat;
  energyFlat: Energyflat;
  energyFlatContract: Energyflat;

  salaryData = new Map<number, {marketMasterId: number, numberOfAccountings: number, ignore: boolean}>();
  totalNumberOfAccountings = 0;
  totalNumberOfIgnoredAccountings = 0;

  newAccountingView: boolean;

  checklistClose: Array<any>;
  showPreviewImage: Array<Array<boolean>>;

  electricMeters: Electricmeter[];
  marketdateMeterreading: MarketdateMeterreading[];

  discounts = new Map<number, Discount>();

  marketMasterStatusList = [MarketmasterStatusEnum.Work,
    MarketmasterStatusEnum.PaidLeave,
    MarketmasterStatusEnum.SickLeave,
    MarketmasterStatusEnum.NoPay];

  marketMasterStatuses = [MarketmasterStatusEnum.Work, MarketmasterStatusEnum.Work, MarketmasterStatusEnum.Work];

  marketdateCommentImageSelectionMode = false;
  selectedMarketdateCommentsImages: Array<MarketDateCommentImages> = [];

  merchantSearchContact: Contact;
  searchInputMerchant: string;
  merchantSalesunits: Salesunit[];
  selectedSalesunit: Salesunit = new Salesunit();
  isMerchantPresent = false;
  addMerchantStatusError;

  apiStatus = {
    marketAccounting: ApiStatus.NotLoaded,
    marketMasters: ApiStatus.NotLoaded,
    marketMasterAccountings: ApiStatus.NotLoaded,
    additionalFlats: ApiStatus.NotLoaded,
    energyFlats: ApiStatus.NotLoaded,
    numberOfMarketAccountings: []
  };

  trainingSystem = TRAINING;

  parseInt = parseInt;

  constructor(private jhiLanguageService: JhiLanguageService,
              private apiService: ApiService,
              private route: ActivatedRoute,
              public routingData: RoutingDataService,
              public modalService: NgbModal,
              public router: Router,
              private principal: Principal,
              private osmNominatimService: OsmNominatimService,
              private winterService: WinterService,
              private localStorage: LocalStorageService,
              private datePipe: DatePipe,
              private numberPipe: DecimalPipe,
              private assortmentService: AssortmentService,
              private fileService: FileService,
              private accountService: AccountService,
  ) {

    this.jhiLanguageService.setLocations(['market-detail']);
    this.route.parent.url.subscribe(parentUrl => {
      this.parentUrl = parentUrl.toString();
    });

    if (!this.cancelStatus) {
      this.cancelStatus = [];
      this.cancelStatus.push({
        value: MarketStatus.CanceledWeather,
        label: MarketStatus.CanceledWeather.toString(),
        selected: false
      });
      this.cancelStatus.push({
        value: MarketStatus.CanceledOtherEvent,
        label: MarketStatus.CanceledOtherEvent.toString(),
        selected: false
      });

      this.accountService.get().subscribe((user: User) => {
        this.user = user;
      });
    }

    this.assortment = [
      {name: 'Obst und Gemüse', value: 'Obst und Gemüse'},
      {name: 'Fleisch und Wurstwaren', value: 'Fleisch und Wurstwaren'},
      {name: 'Geflügel aller Art', value: 'Geflügel aller Art'},
      {name: 'Käse, Milchprodukte, Eier', value: 'Käse, Milchprodukte, Eier'},
      {name: 'Brot- und Backwaren', value: 'Brot- und Backwaren'},
      {name: 'Fisch', value: 'Fisch'},
      {name: 'Feinkost', value: 'Feinkost'},
      {name: 'Süßwaren und Honig', value: 'Süßwaren und Honig'},
      {name: 'Imbiss/Getränke', value: 'Imbiss/Getränke'},
      {name: 'Alkoholische Getränke', value: 'Alkoholische Getränke'},
      {name: 'Blumen und Pflanzen', value: 'Blumen und Pflanzen'},
      {name: 'Korbwaren', value: 'Korbwaren'},
      {name: 'Holzschnitzereien', value: 'Holzschnitzereien'},
      {name: 'Gewürze, Tee, Kräuter, Beeren, Öl', value: 'Gewürze, Tee, Kräuter, Beeren, Öl'},
      {name: 'Tierfelle', value: 'Tierfelle'},
      {name: 'Vieh', value: 'Vieh'},
      {name: 'Sonstiges', value: 'Sonstiges'},
    ];

    this.assortmentExtended = [
      {name: 'Kurzwaren', value: 'Kurzwaren'},
      {name: 'Haushaltswaren', value: 'Haushaltswaren'},
      {name: 'Stoffe/Tücher', value: 'Stoffe/Tücher'},
      {name: 'Textilien', value: 'Textilien'},
      {name: 'Trikotagen', value: 'Trikotagen'},
      {name: 'Lederwaren', value: 'Lederwaren'},
      {name: 'Toilettenartikel', value: 'Toilettenartikel'},
      {name: 'Gartenbedarf', value: 'Gartenbedarf'},
      {name: 'Ton-/Datenträger', value: 'Ton-/Datenträger'},
      {name: 'Modeschmuck', value: 'Modeschmuck'},
      {name: 'Spielwaren/Bücher/Bilder', value: 'Spielwaren/Bücher/Bilder'},
      {name: 'Sonstiges', value: 'Sonstiges'},
    ];

    this.discountOptions = {
      single: [],
      periodic: [],
      socialorganization: []
    };

    [25, 50, 100].forEach(singlePercentage => {
      this.discountOptions.single.push({
        label: singlePercentage + ' %',
        value: singlePercentage / 100
      });

      this.discountOptions.socialorganization.push({
        label: singlePercentage + ' %',
        value: singlePercentage / 100
      });
    });

    for (let _i = 1; _i <= 20; _i++) {
      this.discountOptions.periodic.push({
        label: _i + ' %',
        value: _i / 100
      });
    }

    this.discountDurationOptions = [];
    for (let _i = 1; _i <= 52; _i++) {
      this.discountDurationOptions.push({
        label: (_i === 1) ? _i + ' Woche' : _i + ' Wochen',
        value: _i
      });
    }
  }

  ngAfterViewInit() {

  }


  ngOnInit() {
    this.principal.identity().then((account) => {
      this.account = account;
    });

    this.marketMasterAccountings = [];
    this.marketMasterAccountingsSum = {
      boothTotalSum: 0,
      expenseTotalSum: 0,
      totalSum: 0
    };
    this.marketMasterExpenses = [];
    this.route.params.subscribe(params => {
      const marketdateId = +params['id'];
      this.marketDateId = marketdateId;
      this.localStorage.store('lastMarketDetail', this.parentUrl + '/' + this.marketDateId);
      this.findContactTempsByMarketdate(marketdateId).then(() => this.load(marketdateId));
      this.findMarketdate(marketdateId);
    });

  }

  /**
   * Check if the data can be sent to erp or not
   *
   * @returns true if all required data are loaded
   */
  canSendToERP(): boolean {
    return this.apiStatus.marketMasterAccountings === ApiStatus.Loaded
      // Checks if all market accountings for every market master are loaded
      && !this.apiStatus.numberOfMarketAccountings.some((entry) => entry !== ApiStatus.Loaded)
      && this.apiStatus.marketAccounting === ApiStatus.Loaded
      && this.marketAccounting.marketOverviewEntry.status !== 'Unopened'
      && this.marketAccounting.marketOverviewEntry.status !== 'Opened'
      && !this.marketHasMerchantModifications()
      && !this.confirmationDisabled
      && !this.hasMessagesWithoutAction()
      && !this.hasChecklistWithoutAction();
  }

  canConfirmMarket(): boolean {
    return !this.apiStatus.numberOfMarketAccountings.some((entry) => entry !== ApiStatus.Loaded)
      && this.apiStatus.marketMasterAccountings === ApiStatus.Loaded
      && !this.loadingIndicator;
  }

  load(id: number) {
    if (!this.context) {
      this.context = (this.canvasEl.nativeElement as HTMLCanvasElement).getContext('2d');
    }
    this.loadingIndicator = true;
    this.apiStatus.marketAccounting = ApiStatus.Loading;
    this.apiService.findOne<MarketAccounting>(MarketAccounting, 'backoffice/accounting/' + id)
      .subscribe(
      {
        next: (marketAccounting) => {
          this.apiStatus.marketAccounting = ApiStatus.Loaded;
          marketAccounting.electricMeterInfo = marketAccounting.electricMeterInfo
            .sort((a: ElectricMeter, b: ElectricMeter) => {
              if (a.location === b.location) {
                return ((a.number) ? a.number : '').localeCompare((b.number) ? b.number : '');
              } else {
                return ((a.location) ? a.location : '').localeCompare((b.location) ? b.location : '');
              }
            });
          marketAccounting.marketOverviewEntry.marketDateComments =
            plainToClass(MarketDateComment, marketAccounting.marketOverviewEntry.marketDateComments);
          this.marketAccounting = marketAccounting;
          this.localStorage.store('lastMarketDetailTitle',
            this.marketAccounting.title + ' - ' + this.datePipe.transform(this.marketAccounting.date, 'dd.MM.yyyy'));

          this.currentMarketStatus = this.marketAccounting.marketOverviewEntry.marketdateStatuses.filter(
            marketdateStatus => marketdateStatus.status.toString() ===
              this.marketAccounting.marketOverviewEntry.status)[0];

          this.marketStatusOpen = this.marketAccounting.marketOverviewEntry.marketdateStatuses.find(
            marketdateStatus => marketdateStatus.status === MarketStatus.Opened);

          this.marketStatusClosed = this.marketAccounting.marketOverviewEntry.marketdateStatuses.find(
            marketdateStatus => marketdateStatus.status === MarketStatus.Closed);

          if (this.currentMarketStatus) {
            this.getContactByUserId(this.currentMarketStatus.updatedBy.id).subscribe(modifiedByContact =>
              this.modifiedByContact = modifiedByContact);
          }

          if (this.marketStatusClosed) {
            this.getContactByUserId(this.marketStatusClosed.updatedBy.id).subscribe(closedByContact =>
              this.closedByContact = closedByContact);
          }

          this.checkMarketdateChecklistItems();

          this.canChangeMarketMaser = this.checkDate(this.marketAccounting.date);

          if (!this.marketAccounting.marketOverviewEntry.interimsMarketMaster1) {
            this.marketAccounting.marketOverviewEntry.interimsMarketMaster1 = null;
          }
          if (!this.marketAccounting.marketOverviewEntry.interimsMarketMaster2) {
            this.marketAccounting.marketOverviewEntry.interimsMarketMaster2 = null;
          }
          if (!this.marketAccounting.marketOverviewEntry.interimsMarketMaster3) {
            this.marketAccounting.marketOverviewEntry.interimsMarketMaster3 = null;
          }

          this.tempInterimsMarketmasters = [
            this.marketAccounting.marketOverviewEntry.interimsMarketMaster1,
            this.marketAccounting.marketOverviewEntry.interimsMarketMaster2,
            this.marketAccounting.marketOverviewEntry.interimsMarketMaster3
          ];

          this.filteredMarketAccountingEntries = [];
          this.presentBooths = marketAccounting.marketAccountingEntries.filter(marketAccountingEntry =>
            marketAccountingEntry.status === 'Completed').length;

          const presentBoothsWithEnergyCosts = marketAccounting.marketAccountingEntries.filter(marketAccountingEntry =>
            marketAccountingEntry.status === 'Completed'
            && (
              (marketAccountingEntry.contractType === 'Standard')
                ? ((marketAccountingEntry.energyPriceTypeDivergent !== null && marketAccountingEntry.energyPriceTypeDivergent !== 'Null')
                  ? marketAccountingEntry.energyPriceTypeDivergent !== 'None'
                  : (marketAccountingEntry.ctEnergyType !== null && marketAccountingEntry.ctEnergyType !== 'None'))
                : marketAccountingEntry.energyPriceType !== 'None' && marketAccountingEntry.energyPriceType !== null)
          );
          this.presentBoothsWithEnergyCosts = presentBoothsWithEnergyCosts.length;

          presentBoothsWithEnergyCosts.forEach(completedBooth => {
            this.totalSqmOfBoothsWithEnergyCosts += this.getSqmSum(completedBooth);
          });

          marketAccounting.marketAccountingEntries.filter(marketAccountingEntry =>
            marketAccountingEntry.status === 'Completed' || marketAccountingEntry.status === 'Absent')
            .forEach(completedBooth => {
              this.totalSoldSqm += this.getSqmSum(completedBooth);
            });

          marketAccounting.marketAccountingEntries.filter(marketAccountingEntry =>
            marketAccountingEntry.status === 'Completed').forEach(completedBooth => {
            this.totalSqm += this.getSqmSum(completedBooth);
          });

          // No daily traders with status 'None' on closed markets
          this.filteredMarketAccountingEntries = this.sortMarketAccountingEntries(marketAccounting.marketAccountingEntries).filter(
            marketAccountingEntry => {
              if ((marketAccounting.marketOverviewEntry.status === 'Closed' ||
                  marketAccounting.marketOverviewEntry.status === 'Confirmed') &&
                marketAccountingEntry.contractType === 'None' &&
                marketAccountingEntry.status === 'None') {
                return false;
              } else {
                return marketAccountingEntry;
              }
            });

          this.filteredMarketAccountingEntries.forEach((value, index) => {
            this.filteredMarketAccountingEntries[index]['index'] = index;

            this.filteredMarketAccountingEntries[index]['soldArea'] =
              (this.filteredMarketAccountingEntries[index].status === 'Completed' ||
                this.filteredMarketAccountingEntries[index].status === 'Absent') ?
                this.getSqmSum(this.filteredMarketAccountingEntries[index]) : null;

            this.filteredMarketAccountingEntries[index]['sumOfSettlement'] =
              (this.filteredMarketAccountingEntries[index].status === 'Completed') ?
                this.getSumOfSettlement(this.filteredMarketAccountingEntries[index]) : null;

            this.filteredMarketAccountingEntries[index]['sumOfSettlementCorrect'] =
              ((this.filteredMarketAccountingEntries[index].priceTotal) ?
                (this.getSumOfSettlement(this.filteredMarketAccountingEntries[index]).toFixed(2) ===
                  this.filteredMarketAccountingEntries[index].priceTotal.toFixed(2)) : 'null');

            this.filteredMarketAccountingEntries[index]['cashed'] =
              (this.filteredMarketAccountingEntries[index].status === 'Completed') ?
                this.getCashed(this.filteredMarketAccountingEntries[index]) : null;

            this.filteredMarketAccountingEntries[index]['openBalance'] =
              (this.filteredMarketAccountingEntries[index].status === 'Completed') ?
                this.getOpenBalance(this.filteredMarketAccountingEntries[index]) : null;

            this.filteredMarketAccountingEntries[index]['assortmentCombined'] =
              this.getAssortment(this.filteredMarketAccountingEntries[index].salesunit);

            this.filteredMarketAccountingEntries[index]['winterSize'] =
              (this.winter && this.filteredMarketAccountingEntries[index].salesunit.useWinterSize);

            this.filteredMarketAccountingEntries[index]['salesunitBoothSize'] =
              (this.winter && this.filteredMarketAccountingEntries[index].salesunit.useWinterSize
                && this.filteredMarketAccountingEntries[index].salesunit.boothSizeWinter > 0)
                ? this.filteredMarketAccountingEntries[index].salesunit.boothSizeWinter
                : this.filteredMarketAccountingEntries[index].salesunit.boothSize;

            // Gebuchte Standfläche
            if (this.filteredMarketAccountingEntries[index].contractType === 'Standard') {
              this.getContractHistory(this.filteredMarketAccountingEntries[index], new Date(this.marketDate.evasiveDate))
                .then(contractHistory => {
                  this.filteredMarketAccountingEntries[index]['bookedArea'] =
                    ((this.winter && contractHistory.useWinterSize)
                      ? contractHistory.sizeWinter + contractHistory.sizeWinterAdditional
                      : contractHistory.size + contractHistory.sizeAdditional);
                })
                .catch(error => this.filteredMarketAccountingEntries[index]['bookedArea'] = '?');
            }

            this.filteredMarketAccountingEntries[index]['salesunitContactDisplayname'] =
              (this.filteredMarketAccountingEntries[index].salesunitContact &&
                this.filteredMarketAccountingEntries[index].salesunitContact.displayname) ?
                this.filteredMarketAccountingEntries[index].salesunitContact.displayname : null;

            this.filteredMarketAccountingEntries[index]['merchantModifications'] =
              (this.merchantModifications[this.filteredMarketAccountingEntries[index].merchantId]) ?
                this.merchantModifications[this.filteredMarketAccountingEntries[index].merchantId] : [];
          });

          this.filteredMarketAccountingEntries
            .filter(marketAccountingEntry => marketAccountingEntry.status === 'Completed')
            .filter(marketAccountingEntry => this.getSalesunitAssortmentType(marketAccountingEntry.salesunit, true)
              === 'assortmentExtended')
            .forEach(completedBooth => {
              this.extendedAssortmentSqm += this.getSqmSum(completedBooth);
            });

          this.marketingFeeTemp = this.marketAccounting.marketingFee;

          this.apiStatus.marketMasters = ApiStatus.Loading;
          this.apiService.find<Contact>(Contact, 'market-masters/' + this.marketAccounting.branch)
            .subscribe({
              next: (marketMasters) => {
                this.apiStatus.marketMasters = ApiStatus.Loaded;
                this.possibleTempMarketMasters = marketMasters;
                this.tempInterimsMarketmasters.forEach((tempInterimsMarketMaser, index) => {
                  if (tempInterimsMarketMaser) {
                    this.tempInterimsMarketmasters[index] = this.possibleTempMarketMasters
                      .find(pmm => pmm.id === tempInterimsMarketMaser.id);
                  }
                });
              },
              error: (err) => {
                console.log(err);
                this.apiStatus.marketMasters = ApiStatus.Error;
              }
            });

          const marketMasterIds = [];
          this.marketAccounting.marketMasters.forEach(
            marketMaster => {
              if (!marketMasterIds.includes(marketMaster.id)) {
                this.addMarketMasterData(marketMasterIds, marketMaster);
              }
            }
          );

          [this.marketAccounting.marketOverviewEntry.interimsMarketMaster1,
            this.marketAccounting.marketOverviewEntry.interimsMarketMaster2,
            this.marketAccounting.marketOverviewEntry.interimsMarketMaster3].forEach((interimsMarketMaster, index) => {
            if (interimsMarketMaster) {
              if (!marketMasterIds.includes(interimsMarketMaster.id)) {
                this.addMarketMasterData(marketMasterIds, interimsMarketMaster);
              }
            }
          });

          // Check if another contact except the regular marketMasters or interimsMarketMasters settled merchants.
          const completedBooths = this.marketAccounting.marketAccountingEntries.filter(booth => booth.status === 'Completed');
          const uniqueUpdatedByContactSimplified = this.removeDuplicates(
            [...Array.from(new Set(completedBooths.map(booth => booth.updatedByContactSimplified)))],
            'id');

          const mmContactIds = [];
          const iMmContactIds = [];

          this.marketAccounting.marketMasters.forEach(mm => mmContactIds.push(mm.id));
          [this.marketAccounting.marketOverviewEntry.interimsMarketMaster1,
            this.marketAccounting.marketOverviewEntry.interimsMarketMaster2,
            this.marketAccounting.marketOverviewEntry.interimsMarketMaster3].forEach(iMm => (iMm) ? iMmContactIds.push(iMm.id) : null);

          const otherContacts = [];

          uniqueUpdatedByContactSimplified.forEach(uubcs => {
            if (uubcs && !mmContactIds.includes(uubcs.id) && !iMmContactIds.includes(uubcs.id)) {
              otherContacts.push(uubcs);
            }
          });

          otherContacts.forEach(otherContact => {
              if (!marketMasterIds.includes(otherContact.id)) {
                this.apiService.find<MarketAccountingEntry>(
                  MarketAccountingEntry,
                  'backoffice/market-accountings-backoffice/' + id + '/' + otherContact.id
                ).subscribe(marketAccountingEntries => {
                  this.addMarketMasterData(marketMasterIds, otherContact);
                });
              }
            }
          );

          // Load Images:
          this.marketAccounting.marketOverviewEntry.marketDateComments.forEach(
            (marketDateComment) => {
              if (!marketDateComment.image && marketDateComment.imageUploaded) {
                this.apiService.getImage(['marketdate-comments', marketDateComment.id, 'image', '1'].join('/')).subscribe((image: Blob) => {
                  const fileReader = new FileReader();
                  fileReader.onload = () => this.processMarketdateCommentImage(
                    marketDateComment, fileReader.result, marketDateComment.imageCreated, 1);
                  fileReader.readAsDataURL(new File([image], 'image', {type: 'image/jpeg'}));
                });
              }
              if (!marketDateComment.image2 && marketDateComment.image2Uploaded) {
                this.apiService.getImage(['marketdate-comments', marketDateComment.id, 'image', '2'].join('/')).subscribe((image: Blob) => {
                  const fileReader = new FileReader();
                  fileReader.onload = () => this.processMarketdateCommentImage(
                    marketDateComment, fileReader.result, marketDateComment.image2Created, 2);
                  fileReader.readAsDataURL(new File([image], 'image2', {type: 'image/jpeg'}));
                });
              }
              if (!marketDateComment.image3 && marketDateComment.image3Uploaded) {
                this.apiService.getImage(['marketdate-comments', marketDateComment.id, 'image', '3'].join('/')).subscribe((image: Blob) => {
                  const fileReader = new FileReader();
                  fileReader.onload = () => this.processMarketdateCommentImage(
                    marketDateComment, fileReader.result, marketDateComment.image3Created, 3);
                  fileReader.readAsDataURL(new File([image], 'image3', {type: 'image/jpeg'}));
                });
              }
            }
          );

          this.loadingIndicator = false;

          this.setDataTableColumnModeToForce();
        },
        error: (err) => {
          console.log(err);
          this.apiStatus.marketAccounting = ApiStatus.Error;
        }
      }
    );
  }

  processMarketdateCommentImage(marketDateComment: MarketDateComment, image: any, imageDate: string, imageIndex: number) {
    if (imageIndex === 1) {
      marketDateComment.image = image;
      this.addCaptionToImage(marketDateComment, image, imageDate, imageIndex);
    } else if (imageIndex === 2) {
      marketDateComment.image2 = image;
      this.addCaptionToImage(marketDateComment, image, imageDate, imageIndex);
    } else if (imageIndex === 3) {
      marketDateComment.image3 = image;
      this.addCaptionToImage(marketDateComment, image, imageDate, imageIndex);
    }

  }

  addMarketMasterData(marketMasterIds: Array<number>, marketMaster: any, noSalary = false) {
    this.confirmationDisabled = true;
    this.apiStatus.numberOfMarketAccountings[marketMaster.id] = ApiStatus.Loading;
    this.apiService.findOneRegularNumber( 'backoffice/number-of-market-accountings-backoffice/'
      + this.marketDate.id + '/' + marketMaster.id)
      .subscribe(
        {
          next: (numberOfAccountigs) => {
            this.salaryData.set(marketMaster.id,
              {marketMasterId: marketMaster.id, numberOfAccountings: numberOfAccountigs, ignore: noSalary});
            if (!noSalary) {
              this.totalNumberOfAccountings += numberOfAccountigs;
            } else {
              this.totalNumberOfIgnoredAccountings += numberOfAccountigs;
            }
            this.apiStatus.numberOfMarketAccountings[marketMaster.id] = ApiStatus.Loaded;
          },
          error: (err) => {
            console.log(err);
            this.apiStatus.numberOfMarketAccountings[marketMaster.id] = ApiStatus.Error;
          }
        }
      );


    this.apiStatus.marketMasterAccountings = ApiStatus.Loading;
    this.apiService.find<MarketAccountingEntry>(
      MarketAccountingEntry,
      'backoffice/market-accountings-backoffice/' + this.marketDate.id +  '/' + marketMaster.id
    ).subscribe({
      next: (marketAccountingEntries) => {
        this.marketMasterAccountings.push(
          {
            mmDisplayName: (marketMaster.user.firstName) ? marketMaster.user.firstName + ' ' + marketMaster.user.lastName : '',
            mmNumber: (marketMaster.number) ? marketMaster.number : ((marketMaster.merchantNumber) ? marketMaster.merchantNumber  : ''),
            mmId: marketMaster.id,
            boothTotal: marketAccountingEntries.filter(entry => entry.type === MarketAccountingEntryType.BoothTotal),
            // expenseTotal: marketAccountingEntries.filter(entry => entry.type === MarketAccountingEntryType.ExpenseTotal),
            // FIX 16.06.2020
            expenseTotal: marketAccountingEntries.filter(entry => (entry.type === MarketAccountingEntryType.DeviceRefund
              || entry.type === MarketAccountingEntryType.Expense)).reduce((a, b) => a + b.amount, 0),
            // FIX END
            total: marketAccountingEntries.filter(entry => entry.type === MarketAccountingEntryType.Total),
            mmStatus: this.getStatusByMMId(marketMaster.id),
            position: this.getPositionByMMId(marketMaster.id)
          }
        );

        this.marketMasterAccountings.sort(
          (a, b) => {
            if (a.position < b.position) {
              return -1;
            }
            if (a.position > b.position) {
              return 1;
            }
            return 0;
          }
        );

        const boothTotals = marketAccountingEntries.filter(entry => entry.type === MarketAccountingEntryType.BoothTotal);
        // const expenseTotals = marketAccountingEntries.filter(entry => entry.type === MarketAccountingEntryType.ExpenseTotal);
        // FIX 16.06.2020
        const expenseTotals = marketAccountingEntries.filter(entry => (entry.type === MarketAccountingEntryType.DeviceRefund
          || entry.type === MarketAccountingEntryType.Expense));
        // FIX END
        const totals = marketAccountingEntries.filter(entry => entry.type === MarketAccountingEntryType.Total);

        const boothTotalSum = boothTotals.map(boothTotal => boothTotal.amount).reduce((a, b) => a + b, 0);
        const expenseTotalSum = expenseTotals.map(expenseTotal => expenseTotal.amount).reduce((a, b) => a + b, 0);
        const totalSum = totals.map(total => total.amount).reduce((a, b) => a + b, 0);

        this.marketMasterAccountingsSum.boothTotalSum += boothTotalSum;
        this.marketMasterAccountingsSum.expenseTotalSum += expenseTotalSum;
        this.marketMasterAccountingsSum.totalSum += totalSum;

        this.marketMasterExpenses.push({
          marketMaster: marketMaster,
          expenses:  marketAccountingEntries.filter(
            entry => entry.type === MarketAccountingEntryType.Expense || entry.type === MarketAccountingEntryType.DeviceRefund
          )
        });
        this.confirmationDisabled = false;
        this.apiStatus.marketMasterAccountings = ApiStatus.Loaded;
      },
      error: (err) => {
        console.log(err);
        marketMasterIds.push(marketMaster.id);
        this.apiStatus.marketMasterAccountings = ApiStatus.Error;
      }
    });
    marketMasterIds.push(marketMaster.id);
  }

  findAdditionalFlats(marketPlaceId: number) {
    this.apiStatus.additionalFlats = ApiStatus.Loading;
    this.apiService.find<Additionalflat>(Additionalflat, 'marketplaces/' + marketPlaceId + '/additionalflats').subscribe(
      {
        next: (additionalFlats) => {
          this.apiStatus.additionalFlats = ApiStatus.Loaded;
          this.additionalFlat = additionalFlats
            .sort((a, b) => {
              const timeA = new Date(a.validFrom).getTime();
              const timeB = new Date(b.validFrom).getTime();
              if (timeA > timeB) { return -1; }
              if (timeA < timeB) { return 1; }
              if (a.id > b.id) { return -1; }
              if (a.id < b.id) { return 1; }
              return 0;
            })
            .filter(additionalFlatItem => additionalFlatItem.priceType === 'B'
              && new Date(additionalFlatItem.validFrom).getTime() <= new Date(this.marketDate.evasiveDate).getTime())[0];
          this.additionalFlatContract = additionalFlats
            .sort((a, b) => {
              const timeA = new Date(a.validFrom).getTime();
              const timeB = new Date(b.validFrom).getTime();
              if (timeA > timeB) { return -1; }
              if (timeA < timeB) { return 1; }
              if (a.id > b.id) { return -1; }
              if (a.id < b.id) { return 1; }
              return 0;
            })
            .filter(additionalFlatItem => additionalFlatItem.priceType === 'N'
              && new Date(additionalFlatItem.validFrom).getTime() <= new Date(this.marketDate.evasiveDate).getTime())[0];
        },
        error: (err) => {
          console.log(err);
          this.apiStatus.additionalFlats = ApiStatus.Error;
        }
      }
    );
  }

  findEnergyFlats(marketDayId: number) {
    this.apiStatus.energyFlats = ApiStatus.Loading;
    this.apiService.find<Energyflat>(Energyflat, 'marketdays/' + marketDayId + '/energyflats').subscribe(
      {
        next: (energyFlats) => {
          this.apiStatus.energyFlats = ApiStatus.Loaded;
          let validFrom = null;

          let energyFlatsNonContract = energyFlats.filter(energyFlatItem => energyFlatItem.priceType === 'B'
            && new Date(energyFlatItem.validFrom).getTime() <= new Date(this.marketDate.evasiveDate).getTime())
            .sort((a, b) => new Date(b.validFrom).getTime() - new Date(a.validFrom).getTime());
          if (energyFlatsNonContract.length > 0) {
            validFrom = energyFlatsNonContract[0].validFrom;
          }
          energyFlatsNonContract = energyFlatsNonContract.filter(energyFlatItem => energyFlatItem.validFrom === validFrom)
            .sort((a, b) => new Date(b.updated).getTime() - new Date(a.updated).getTime());
          this.energyFlat = energyFlatsNonContract[0];

          let energyFlatContract = energyFlats.filter(energyFlatItem => energyFlatItem.priceType === 'N'
            && new Date(energyFlatItem.validFrom).getTime() <= new Date(this.marketDate.evasiveDate).getTime())
            .sort((a, b) => new Date(b.validFrom).getTime() - new Date(a.validFrom).getTime());
          if (energyFlatContract.length > 0) {
            validFrom = energyFlatContract[0].validFrom;
          }
          energyFlatContract = energyFlatContract.filter(energyFlatItem => energyFlatItem.validFrom === validFrom)
            .sort((a, b) => new Date(b.updated).getTime() - new Date(a.updated).getTime());
          this.energyFlatContract = energyFlatContract[0];

        },
        error: (err) => {
          console.log(err);
          this.apiStatus.energyFlats = ApiStatus.Error;
        }
      }
    );
  }

  getEnergyPrice(energyPriceType: EnergyPriceType, grossOrNet: 'B' | 'N'): number {
    if (grossOrNet === 'B' && this.energyFlat) {
      switch (energyPriceType) {
        case EnergyPriceType.Low:
          return this.energyFlat.priceLow;
        case EnergyPriceType.Normal:
          return this.energyFlat.priceNormal;
        case EnergyPriceType.Special:
          return this.energyFlat.priceSpecial;
        default:
          return 0;
      }
    } else if (grossOrNet === 'N' && this.energyFlatContract) {
      switch (energyPriceType) {
        case EnergyPriceType.Low:
          return this.energyFlatContract.priceLow;
        case EnergyPriceType.Normal:
          return this.energyFlatContract.priceNormal;
        case EnergyPriceType.Special:
          return this.energyFlatContract.priceSpecial;
        default:
          return 0;
      }
    } else {
      return 0;
    }
  }

  sortMarketAccountingEntries(marketAccountingEntries: BackofficeMarketAccountingEntry[]) {
    let firstBlock = [];
    let secondBlock = [];
    let thirdBlock = [];

    // First sort by last accounting date:
    marketAccountingEntries = marketAccountingEntries.sort(
      (a: BackofficeMarketAccountingEntry, b: BackofficeMarketAccountingEntry) => {
        if (a.lastAccount > b.lastAccount) {
          return -1;
        }
        if (a.lastAccount < b.lastAccount) {
          return 1;
        }
        return 0;
      }
    );

    /*
    * Disable this obscure filtering. It doesn't work correctly anyway. MG-1055
    const dailyMerchantIds = [];

    if (this.parentUrl === 'planning') {
      marketAccountingEntries.forEach(
        (booth, index) => {
          if (booth.contractType === 'None' && booth.salesunit.merchant) {
            if (dailyMerchantIds[booth.salesunit.merchant.id] ) {
              marketAccountingEntries.splice(index, 1);
            } else {
              dailyMerchantIds[booth.salesunit.merchant.id] = true;
            }
          }
        }
      );
    }
     */

    // Last accounting older than 8 days ago
    thirdBlock = marketAccountingEntries.filter((booth: BackofficeMarketAccountingEntry) => {
      return moment(booth.lastAccount).isBefore(moment(new Date()).subtract(8, 'days'));
    });

    // Last accounting NOT older than 8 days ago
    const lastWeek = marketAccountingEntries.filter((booth: BackofficeMarketAccountingEntry) => {
      return !moment(booth.lastAccount).isBefore(moment(new Date()).subtract(8, 'days'));
    });

    // Split last week in Completed (first block) and Absent (secondBlock)
    firstBlock = lastWeek.filter((booth: BackofficeMarketAccountingEntry) => {
      return booth.lastStatus === 'Completed';
    });

    secondBlock = lastWeek.filter((booth: BackofficeMarketAccountingEntry) => {
      return booth.lastStatus === 'Absent' || !booth.lastStatus || booth.lastStatus === 'None';
    });

    // console.log('last  week : ', lastWeek);
    // console.log('------------');
    // console.log('first block: ', firstBlock);
    // console.log('secon block: ', secondBlock);
    // console.log('third block: ', thirdBlock);
    // console.log('------------');
    // console.log('concat block: ', firstBlock.concat(secondBlock).concat(thirdBlock));

    return firstBlock.concat(secondBlock).concat(thirdBlock);
  }

  getAssortment(salesunit: Salesunit) {
    return this.assortmentService.getAssortmentsWithSeparator(salesunit.getAssortments());
  }

  valueIsNotEmptyStringOrNull(val) {
    return val !== '' && val !== null;
  }

  getCashed(bomae: BackofficeMarketAccountingEntry) {
    let result = 0;
    if (!bomae.noPaymentReceived && bomae.partialPaymentReceived) {
      result = bomae.partialPayment;
    } else if (!bomae.noPaymentReceived && !bomae.partialPaymentReceived && bomae.paidAmount) {
      result = bomae.paidAmount;
    }
    return result;
  }

  getOpenBalance(bomae: BackofficeMarketAccountingEntry) {
    let result = 0;
    if (!bomae.noPaymentReceived && bomae.partialPaymentReceived) {
      result = bomae.priceTotal - bomae.partialPayment;
    } else if (bomae.noPaymentReceived && !bomae.partialPaymentReceived) {
      result = bomae.priceTotal;
    }
    return result;
  }

  removeDuplicates(myArr, prop) {
    return myArr.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
  }

  setDataTableColumnModeToForce() {
    if (this.marketAccountingEntryTable) {
      this.marketAccountingEntryTable.columnMode = ColumnMode.force;
    } else {
      setTimeout(() => {
        this.setDataTableColumnModeToForce();
      }, 100);
    }
  }

  findMarketdate(marketdateId: number) {
    this.apiService.findOneRegular<Marketdate>(Marketdate, 'marketdates/' + marketdateId).subscribe(
      marketDate => {
        this.marketDate = marketDate;
        this.winter = this.winterService.isWinter(this.marketDate.evasiveDate);
        this.openingDuration = this.winter ? this.marketDate.marketday.openingDurationWinter
          : this.marketDate.marketday.openingDurationSummer;
        switch (this.marketDate.marketday.classification) {
          case 'Nachmittagsmarkt':
          case 'Vormittagsmarkt':
            this.halfOrFullDay = 'halfDay';
            break;
          case 'Ganztagsmarkt':
          default:
            this.halfOrFullDay = 'fullDay';
            break;
        }
        this.marketDateIsInPast = this.marketdateInPast();
        this.findBoothFees(marketDate.marketday.id);
        this.getMessages(marketDate);
        this.getDepositMessages(marketDate);
        this.getBranchNotes(marketDate);
        this.findAdditionalFlats(this.marketDate.marketday.marketplace.id);
        this.findEnergyFlats(this.marketDate.marketday.id);
        this.getDiscountsForMarketdate(marketdateId);
        this.setMarketMasterStatuses();
        this.getOpenPayments(this.marketDate.marketday.id);
        this.getReadMessageCount(marketDate);
      }
    );
  }

  findBoothFees(marketDayId: number) {
    this.apiService.find<Boothfee>(Boothfee, 'marketdays/' + marketDayId + '/boothfees').subscribe(
      boothFees => {
        const boothFeesContract = boothFees
          .sort((a, b) => new Date(b.validFrom).getTime() - new Date(a.validFrom).getTime())
          .filter(boothFeeItem => boothFeeItem.priceType === 'N'
            && new Date(boothFeeItem.validFrom).getTime() <= new Date(this.marketDate.evasiveDate).getTime());
        if (boothFeesContract.length > 0) {
          this.boothFeeContract = boothFeesContract[0];
        }
        this.boothFee = boothFees
          .sort((a, b) => new Date(b.validFrom).getTime() - new Date(a.validFrom).getTime())
          .filter(boothFeeItem => boothFeeItem.priceType === 'B'
            && new Date(boothFeeItem.validFrom).getTime() <= new Date(this.marketDate.evasiveDate).getTime())[0];
        this.boothFeeSqmPrice = this.boothFee.priceCategoryB;
      }
    );
  }

  /**
   * Get the total messages count and total messages read count as number array from an given marketdate
   */
  getReadMessageCount(marketdate: Marketdate) {
    this.apiService.findRegular<Number>(Number, 'message-counts-by-marketday-without-deposits/' + marketdate.marketday.id)
      .subscribe(count => {
        count.sort((a, b) => a > b ? 1 : (a < b ? -1 : 0));
         this.messagesCounters = count;
      }, error => {
        console.log('error loading message count', error);
      });

    this.apiService.findRegular<Number>(Number, 'deposit-counts-by-marketday/' + marketdate.marketday.id)
      .subscribe(count => {
        count.sort((a, b) => a > b ? 1 : (a < b ? -1 : 0));
        this.depositCounters = count;
      }, error => {
        console.log('error loading message count', error);
      });
  }

  /**
   * Gets the messages page from the spezified marketdate. Caches all requested pages by default for faster loading.
   * You can specify an page index, to query an specific messges page.
   *
   * @param marketdate - The marketdate to get messages from
   * @param page - The index of the messages page to query (uses current page by default)
   * @param ignoreCache - Set this to true to ignore the cache & reload messages
   * @param markAsRead - Should the messages get marked as read
   */
  getMessages(marketdate: Marketdate, page?, ignoreCache?, markAsRead?: boolean) {
    const markAsReadFlag = (markAsRead) ? 'true' : 'false';
    if (page === undefined || page === null) { page = this.messagesPage; }
    // checks if the requested page is cached and just use that
    if (!ignoreCache && this.messagesPages && this.messagesPages[page]) {
      const tmp: any[] = JSON.parse(this.messagesPages[page]);
      this.messages = plainToClass(Message, tmp);
      this.messagesPage = page;
      return;
    }
    this.messagesLoading = true;
    this.getReadMessageCount(this.marketDate);
    this.apiService.findRegular<Message>(Message, 'messages-by-marketday-without-deposits/'
      + marketdate.marketday.id + '/' + markAsReadFlag + '/?page=' + page + '&size=' + this.messagesPageSize)
      .subscribe(messages => {
        this.messages = plainToClass(Message, messages);
        this.messagesPages[page] = messages; // cache the messages, so that we don't need to get them again
        this.countOfUnreadMessages = this.messages.filter(m => m.read === false).length;
        this.messagesPage = page;
        this.messagesLoading = false;

      }, error => {
        console.log('error loading messages', error);
        this.messagesLoading = false;
      });
  }

  getDepositMessages(marketdate: Marketdate, page?) {
    if (page !== 0 && !page) { page = this.depositsPage; }

    let pageSize = this.depositsPageSize;
    if (this.depositCounters && (page + 2) * this.depositsPageSize > this.depositCounters[1]) {
      pageSize = this.depositsPageSize + (parseInt(this.depositCounters[1].toString(), 10) - (page + 2) * this.depositsPageSize);
    }

    this.depositsLoading = true;

    this.apiService.findRegular<Message>(Message, 'deposits-by-marketday/'
      + marketdate.marketday.id + '?page=' + page + '&size=' + pageSize)
      .subscribe(deposits => {
        deposits = deposits.filter(msg => msg.messageType === MessageType.DepositReceipt);
        this.deposits = deposits;
        this.depositsPage = page;
        this.depositsLoading = false;
      }, error => {
        console.log('error loading messages', error);
        this.deposits = [];
        this.depositsLoading = false;
      });
  }

  /**
   * Checks if the message action button is allowed to be displayed.
   */
  canDisplayMessageActionBtn(message: Message): boolean {
    const marketDate = moment(this.marketDate.evasiveDate);
    const msgDate = moment(message.created);
    if (message.messageType !== MessageType.Note
      || moment(this.marketDate.evasiveDate).isBefore(moment('2021-01-01'), 'days')
      || msgDate.isBefore(moment('2021-01-01'), 'days')) {
      return false;
    }
    return (message.marketdates && message.marketdates.length > 0 && message.marketdates.some(md => md.id === this.marketDate.id))
      || ((message.marketdate && message.marketdate.id === this.marketDate.id)
        || ((message.marketday.id === this.marketDate.marketday.id)
          && (moment(message.created).isSame(this.marketDate.evasiveDate, 'day')
            || moment(message.created).isAfter(this.marketDate.evasiveDate, 'day'))))
      && (message.actionCreated === undefined || message.actionCreated === null);
  }

  /**
   * Set a message action and send it to the server
   */
  setMessageAction(message: Message | MarketDateComment, actionType, comment?, email?) {
    if (message.actionCreated) { return; }
    message.actionCreated = new Date();
    message.actionCreatedBy = this.user.contact;
    message.actionType = actionType;
    message.actionComment = comment ? comment : null;
    message.actionEmail = email ? email : null;

    if (message instanceof Message) {
      this.apiService.putRegular(message, 'messages')
        .subscribe({
          next: (result) => {
            console.log('Message action set. ', result);
          },
          error: (error) => console.log('Error sending message action: ', error)
        });
    }
    if (message instanceof MarketDateComment) {
      message.marketdate = this.marketDate;
      const body = JSON.parse(JSON.stringify(message));
      body.image = null;
      body.image2 = null;
      body.image3 = null;
      body.actionCreated = moment().format();
      body.updated = moment().format();
      this.apiService.putRegular(body, 'marketdate-comments')
        // .map(res => deserialize<MarketDateComment>(MarketDateComment, res.json()))
        .subscribe({
        next: (result) => { console.log('Message action set. ', result); },
        error: (error) => console.log('Error sending marketDateComment action: ', error)
      });
    }
  }

  /**
   * Checks if there are messages without action for the current marketDate
   */
  hasMessagesWithoutAction() {
    if (!this.messages || moment(this.marketDate.evasiveDate).isBefore(moment('2021-01-01'), 'days')) { return false; }
    return this.messages.filter(m => m.messageType === MessageType.Note)
      .some(message => {
        return (
          (message.marketdate && message.marketdate.id === this.marketDate.id) ||
          ((message.marketday.id === this.marketDate.marketday.id)
            && (moment(message.created).isSame(this.marketDate.evasiveDate, 'day')
              || moment(message.created).isAfter(this.marketDate.evasiveDate, 'day')))
          )
          && (message.actionCreated === undefined || message.actionCreated === null);
      });
  }

  /**
   * Checks if there is an negative checklist entry without action
   */
  hasChecklistWithoutAction(): boolean {
    return this.getChecklistItems(true).some(item => item.commentType !== CommentType.Info && !item.actionType)
      || this.getChecklistItems(false).some(item => item.commentType !== CommentType.Info && !item.actionType);
  }

  /**
   * Opens EmailComposer to send an message via email. Sets messageAction after email was send.
   * @param message the message to send as email
   * @param images images to add to the email
   */
  sendMessageActionEmail(message: Message | MarketDateComment, images?: any) {
    const date = new Date(message.created);
    let msgBody: string;
    let subject: string;
    let commentImages: MarketDateCommentImages;
    if (message instanceof Message) {
      subject = 'Markttagebuch';
      msgBody = `Nachricht von der Marktleitung ${message.createdBy.displayname}:\n\n${message.content}
      \n\nWeitergeleitet von: ${this.user.contact.displayname}`;
    }
    if (message instanceof MarketDateComment) {
      subject = 'Checkliste';

      msgBody = `Checkliste vom Markt ${this.marketAccounting.title} nicht in Ordnung.\n\n
     ${message.status === 'Opened' ? 'Marktöffnung' : 'Marktschließung'}: ${message.comment} Nein.
      ${message.userComment ? '\n\nKommentar des ML: ' + message.userComment + '\n\n' : ''}
      ${this.marketAccounting.marketOverviewEntry.openedByContact ? 'Marktleitung '
        + this.marketAccounting.marketOverviewEntry.openedByContact.displayName : ''}
      ${images && images.length > 0 ? 'Beweisfotos sind anbei.' : 'Es wurde kein Beweisfoto angefertigt.'}\n\n
      Weitergeleitet von: ${this.user.contact.displayname}`;

      commentImages = new MarketDateCommentImages();
      if (!commentImages.images) { commentImages.images = []; }
      if (message.image) { commentImages.images.push(new MarketDateCommentImage('image', message.image)); }
      if (message.image2) { commentImages.images.push(new MarketDateCommentImage('image2', message.image2)); }
      if (message.image3) { commentImages.images.push(new MarketDateCommentImage('image3', message.image3)); }
      commentImages.id = message.id;
    }
    const msgSubject = `${subject} - ${this.marketDate.marketday.keyword} - ${date.toLocaleDateString()}`;
    this.openEmailComposer(msgBody, msgSubject, commentImages);
    this.modalRef.componentInstance.mailLog.subscribe((result: Log) => {
      this.setMessageAction(message, MessageActionType.EMAIL, null, result);
    });
  }

  getBranchNotes(marketdate: Marketdate) {
    this.apiService.findRegular<Message>(Message, 'branch-notes-by-marketdate/' + marketdate.id)
      .subscribe(branchNotes => {
        this.branchNotes = branchNotes;
      }, error => {
        console.log('error loading branchNotes', error);
        this.branchNotes = [];
      });
  }

  generateNewBranchNote() {
    this.principal.identity().then((user: User) => {
      this.newBranchNote = {
        id: null,
        created: new Date(),
        updated: new Date(),
        marketdate: this.marketDate,
        createdBy: user.contact,
        content: '',
        messageType: MessageType.BranchNoteInternal
      };
    });
  }

  saveBranchNoteInternal(branchNote: Message) {
    if (branchNote.content && branchNote.content !== '') {
      if (branchNote.id) {
        this.apiService.putRegular(branchNote, 'messages/')
          .subscribe(res => {
            this.getBranchNotes(this.marketDate);
            this.branchNoteToEdit = null;
          });
      } else {
        this.apiService.postRegular(branchNote, 'messages/')
          .subscribe(res => {
            this.getBranchNotes(this.marketDate);
            this.newBranchNote = null;
          });
      }
    }
  }

  deleteBranchNote(branchNoteToDelete: Message, query: boolean) {
    if (query) {
      this.branchNoteToDelete = branchNoteToDelete;
      this.openModal(this.removeBranchNoteModal, {size: 'sm', windowClass: 'm pt-2', backdrop: 'static'});
    } else {
      this.apiService.delete('branch-note/' + this.branchNoteToDelete.id)
        .subscribe(res => {
          this.getBranchNotes(this.marketDate);
          this.branchNoteToDelete = null;
        }, error => {
          console.log('error deleting branchNote: ', error);
          this.getBranchNotes(this.marketDate);
          this.branchNoteToDelete = null;
        });
    }
  }

  getOpenPayments(marketdayId) {
    return new Promise((resolve, reject) => {
      this.apiService.find<OpenPayment>(OpenPayment,
        'backoffice-open-payments/' + marketdayId).subscribe((openPayments: Array<OpenPayment>) => {
        this.openPayments = openPayments;
        resolve();
      }, error => reject(error));
    });
  }


  getDiscountsForMarketdate(marketdateId) {
    this.apiService.findRegular<Discount>(Discount, 'discounts-by-marketdate/' + marketdateId)
      .subscribe(discounts => {
        discounts.map( (discount) => {this.discounts.set(discount.merchant.id, discount); });
      }, error => {
        console.log('error loading discounts', error);
        this.discounts = new Map();
      });
  }



  getVisits() {
    const from = new Date(new Date().setFullYear(new Date().getFullYear() - 2)).toISOString().split('T')[0];
    const to = new Date(new Date().setDate(new Date().getDate() - 35)).toISOString().split('T')[0];

    return new Promise((resolve, reject) => {
      this.apiService.get('backoffice/visits/' + this.selectedMerchant.merchantId + '/' + this.marketDate.marketday.id
        + '/' + from + '/' + to)
        .subscribe(visits => {
          this.selectedMerchantVisits = visits.json().sort().reverse();
          resolve();
        }, error => {
          console.log('error getting visits: ', error);
          reject();
        });
    });
  }

  getSalesunitAssortmentChecks(salesunitId: number): Promise<Array<SalesunitAssortmentCheck>> {
    return new Promise<SalesunitAssortmentCheck>((resolve, reject) => {
      this.apiService.find<SalesunitAssortmentCheck>(SalesunitAssortmentCheck,
        ['salesunit-assortment-checks', salesunitId].join('/'))
        .subscribe((salesunitAssortmentChecks: Array<SalesunitAssortmentCheck>) => {
          this.selectedMerchantSalesunitAssortmentChecks = salesunitAssortmentChecks
            .sort((a: SalesunitAssortmentCheck, b: SalesunitAssortmentCheck) =>
              new Date(b.created).getTime() - new Date(a.created).getTime());
          resolve(salesunitAssortmentChecks);
        }, error => {
          console.log('error getting salesunit assortment checks', error);
          this.selectedMerchantSalesunitAssortmentChecks = null;
          reject(null);
        });
    });
  }

  getContractHistory(selectedMerchant: BackofficeMarketAccountingEntry, date: Date): Promise<ContractHistory> {
    return new Promise<ContractHistory>((resolve, reject) => {
      if (selectedMerchant.contractType === 'Standard') {
        this.apiService.findOne<ContractHistory>(ContractHistory,
          'contract-history-by-contract-and-date/' + selectedMerchant.contract.id + '/' + date.toISOString().slice(0, 10))
          .subscribe((contractHistory: ContractHistory) => {
            this.selectedMerchantContractHistory = contractHistory;
            resolve(contractHistory);
          }, error => reject(error));
      } else {
        resolve(null);
      }
    });
  }

  calculateWeeksBetween(date1: Date, date2: Date) {
    // The number of milliseconds in one week
    const ONE_WEEK = 1000 * 60 * 60 * 24 * 7;
    // Convert both dates to milliseconds
    const date1_ms = date1.getTime();
    const date2_ms = date2.getTime();
    // Calculate the difference in milliseconds
    const difference_ms = Math.abs(date1_ms - date2_ms);
    // Convert back to weeks and return hole weeks
    return Math.floor(difference_ms / ONE_WEEK);
  }

  getDiscounts() {
    return new Promise((resolve, reject) => {
      this.apiService.find<Discount>(Discount, 'backoffice-discounts-by/' + this.marketDate.marketday.id + '/'
        + this.selectedMerchant.merchantId).subscribe((discountsResults: Discount[]) => {

        this.selectedMerchantDiscount = discountsResults.find(discount =>
          discount.start <= this.marketDate.evasiveDate && discount.end >= this.marketDate.evasiveDate);
        this.discountEdit = !(this.selectedMerchantDiscount);

        if (!this.selectedMerchantDiscount) {
          this.selectedMerchantDiscount = new Discount();
          this.selectedMerchantDiscount.id = null;
          this.selectedMerchantDiscount.start = this.marketDate.evasiveDate;
          this.selectedMerchantDiscount.end = new Date(new Date(this.marketDate.evasiveDate)
            .setDate(new Date(this.marketDate.evasiveDate).getDate() + 1)).toISOString();
          this.selectedMerchantDiscount.type = null;
          this.selectedMerchantDiscount.salesunit = this.selectedMerchant.salesunit;
          this.selectedMerchantDiscount.percentage = null;
          this.selectedMerchantDiscount.merchant = this.selectedMerchant.merchant;
          this.selectedMerchantDiscount.marketday = this.marketDate.marketday;
          this.selectedMerchantDiscount.comment = '';
          this.selectedMerchantDiscountDuration = null;
        } else {
          this.selectedMerchantDiscountDuration = this.calculateWeeksBetween(new Date(this.selectedMerchantDiscount.start),
            new Date(this.selectedMerchantDiscount.end));
        }

        this.showDiscountVisitHint = false;
        resolve();
      }, error => reject(error));
    });
  }

  getDiscountByMerchant(merchantId: number) {
    return new Promise((resolve, reject) => {
      this.apiService.find<Discount>(Discount, 'backoffice-discounts-by/' + this.marketDate.marketday.id + '/'
        + merchantId).subscribe((discountsResults: Discount[]) => {
        resolve(
          discountsResults.find(discount =>
            discount.start <= this.marketDate.evasiveDate && discount.end >= this.marketDate.evasiveDate)
        );
      }, error => reject(error));
    });
  }

  saveDiscount(discount: Discount) {
    if (discount.id) {
      this.apiService.putRegular(discount, 'discounts').subscribe((response: Response) => {
        this.getDiscounts();
      }, error => {
        console.log('error updating discount', error);
      });
    } else {
      this.apiService.postRegular(discount, 'discounts').subscribe((response: Response) => {
        this.getDiscounts();
      }, error => {
        console.log('error saving discount', error);
      });
    }
  }

  changeDiscountType(discount: Discount, discountType: DiscountType) {
    this.showDiscountVisitHint = false;
    if (!discount.id) {
      this.selectedMerchantDiscount = new Discount();
      this.selectedMerchantDiscount.id = null;
      this.selectedMerchantDiscount.start = this.marketDate.evasiveDate;
      this.selectedMerchantDiscount.end = new Date(new Date(this.marketDate.evasiveDate)
        .setDate(new Date(this.marketDate.evasiveDate).getDate() + 1)).toISOString();
      this.selectedMerchantDiscount.type = null;
      this.selectedMerchantDiscount.salesunit = this.selectedMerchant.salesunit;
      this.selectedMerchantDiscount.percentage = null;
      this.selectedMerchantDiscount.merchant = this.selectedMerchant.merchant;
      this.selectedMerchantDiscount.marketday = this.marketDate.marketday;
      this.selectedMerchantDiscount.comment = '';

      if (discountType === DiscountType.Single && this.selectedMerchantVisits.length > 0) {
        this.showDiscountVisitHint = true;
      }

      if (discountType === DiscountType.SocialOrganization) {
        this.selectedMerchantDiscount.end = new Date('2038-01-19 01:00:42').toISOString();
      }
    }

    this.selectedMerchantDiscount.percentage = null;
    this.selectedMerchantDiscount.type = discountType;
    if (discountType === DiscountType.Single) {
      this.selectedMerchantDiscount.end = new Date(new Date(this.marketDate.evasiveDate)
        .setDate(new Date(this.marketDate.evasiveDate).getDate() + 1)).toISOString();
      this.selectedMerchantDiscountDuration = 0;
    } else if (discountType === DiscountType.Periodic) {
      this.selectedMerchantDiscount.end = new Date(new Date(this.marketDate.evasiveDate)
        .setDate(new Date(this.marketDate.evasiveDate).getDate() + 8)).toISOString();
      this.selectedMerchantDiscountDuration = 1;
    }
  }

  deleteDiscount(discount: Discount) {
    if (discount.id) {
      this.apiService.delete('discounts/' + discount.id).subscribe((response: Response) => {
        this.getDiscounts();
      });
    }
  }

  changeDiscountDuration() {
    this.selectedMerchantDiscount.end = new Date(new Date(this.marketDate.evasiveDate)
      .setDate(new Date(this.marketDate.evasiveDate).getDate() + this.selectedMerchantDiscountDuration * 7 + 1)).toISOString();
  }

  emrAnyNotAccessible() {
    return this.marketAccounting.electricMeterInfo.some(emr => emr.notAccessibleBefore || emr.notAccessibleAfter);
  }

  emrContainsNegativeDeltas() {
    return this.marketAccounting.electricMeterInfo.some(emr =>
      emr.readingAfter.value && emr.readingBefore.value && ((emr.readingAfter.value - emr.readingBefore.value) < 0));
  }

  emrContainsDeviation(): boolean {
    return this.marketAccounting.electricMeterInfo.some(emr => emr.readingBefore.value !== emr.lastMarketdateReadingAfter.value);
  }

  toggleExpandRow(row) {
    this.marketAccountingEntryTable.rowDetail.toggleExpandRow(row);
  }

  showImageModal(title: string, images: any[], index: number = 0, dates: string[]) {
    // deprecated since showImageCarousel
    this.modalTitle = title;
    this.modalImages = images;
    this.modalImageIndex = index;
    this.modalImageDates = dates;

    this.imageModalRef = this.modalService.open(this.imageModal, {size: 'lg', windowClass: 'l'});
    this.imageModalRef.result.then(close => {
      this.modalTitle = this.modalImages = this.modalImageIndex = this.modalImageDates = null;
    }, dismiss => {
      this.modalTitle = this.modalImages = this.modalImageIndex = this.modalImageDates = null;
    });

  }

  showImageCarousel(title: string, images: any[], index: number = 0, dates: string[]) {
    const imageCarouselRef: NgbModalRef = this.modalService.open(ImageCarouselComponent, {size: 'lg', windowClass: 'l'});
    imageCarouselRef.componentInstance.title = title;
    imageCarouselRef.componentInstance.images = images;
    imageCarouselRef.componentInstance.imageIndex = index;
    imageCarouselRef.componentInstance.imageDates = dates;
  }

  showExpenseImages(expense) {
    const images: any[] = [];
    this.loadingOverlay = true;
    const imagePromises = ['image', 'image2', 'image3'].map((imgNo, index) => {
      return new Promise((resolve, reject) => {
        if (expense[imgNo]) {
          images.push('data:image/jpeg;base64,' + expense[imgNo]);
          resolve();
        } else if (!expense[imgNo] && expense[imgNo + 'Uploaded']) {
          this.apiService.getImage(['marketdate-expenses', expense.id, 'image', index + 1].join('/')).subscribe((image: Blob) => {
            const file = new File([image], imgNo, {type: 'image/jpeg'});
            const fileReader = new FileReader();
            fileReader.onload = () => images.push(fileReader.result);
            fileReader.readAsDataURL(file);
            resolve();
          });
        } else {
          resolve();
        }
      });
    });
    Promise.all(imagePromises).then(() => {
      this.loadingOverlay = false;
      this.showImageCarousel('Auslage: ' + expense.description, images, 0, []);
    }).catch(() => {
      this.loadingOverlay = false;
    });
  }

  getImagesFromMarketDateComment(marketDateComment: MarketDateComment): any[] {
    const result = [];

    if (marketDateComment.image !== '' && marketDateComment.image !== null) {
      result.push(((!marketDateComment.imageUploaded) ? 'data:image/jpeg;base64,' : '') +
        marketDateComment.image);
    }
    if (marketDateComment.image2 !== '' && marketDateComment.image2 !== null) {
      result.push(((!marketDateComment.image2Uploaded) ? 'data:image/jpeg;base64,' : '') +
        marketDateComment.image2);
    }
    if (marketDateComment.image3 !== '' && marketDateComment.image3 !== null) {
      result.push(((!marketDateComment.image3Uploaded) ? 'data:image/jpeg;base64,' : '') +
        marketDateComment.image3);
    }

    return result;
  }

  addCaptionsToImages() {
    this.context = (this.canvasEl.nativeElement as HTMLCanvasElement).getContext('2d');
    this.getChecklistItems(true).forEach(
      (marketdateComment) => {
        this.addCaptionToImage(marketdateComment, marketdateComment.image, marketdateComment.imageCreated, 0);
        this.addCaptionToImage(marketdateComment, marketdateComment.image2, marketdateComment.image2Created, 1);
        this.addCaptionToImage(marketdateComment, marketdateComment.image3, marketdateComment.image3Created, 2);
      }
    );
    this.getChecklistItems(false).forEach(
      (marketdateComment) => {
        this.addCaptionToImage(marketdateComment, marketdateComment.image, marketdateComment.imageCreated, 0);
        this.addCaptionToImage(marketdateComment, marketdateComment.image2, marketdateComment.image2Created, 1);
        this.addCaptionToImage(marketdateComment, marketdateComment.image3, marketdateComment.image3Created, 2);
      }
    );
  }

  addCaptionToImage(marketdateComment: MarketDateComment, image: string, imageDate: string, imageIndex: number) {


    const imageData = new Image();
    imageData.onload = () => {
      const textDate = this.datePipe.transform(imageDate, 'dd.MM.yyyy')
        + ' - '
        + this.datePipe.transform(imageDate, 'shortTime') + ' Uhr';
      const textPlace = '' + this.marketAccounting.title;

      const resFactor = imageData.width / 1000;
      const textHeight = 20 * resFactor;

      this.context.font = textHeight + 'px Arial';
      const textDateWidth = this.context.measureText(textDate).width;
      const textPlaceWidth = this.context.measureText(textPlace).width;

      const padding = textHeight;

      (this.canvasEl.nativeElement as HTMLCanvasElement).width = imageData.width;
      (this.canvasEl.nativeElement as HTMLCanvasElement).height = imageData.height;

      this.context.drawImage(imageData, 0, 0);

      this.context.textBaseline = 'middle';

      const dateX = imageData.width - (padding * 2);
      const dateY = imageData.height - (padding * 2);

      const placeX = padding * 2;
      const placeY = imageData.height - (padding * 2);

      this.context.fillStyle = '#000000';
      this.context.globalAlpha = 0.5;
      this.context.fillRect(dateX - textDateWidth - padding, dateY - textHeight, textDateWidth + (padding * 2), textHeight + padding);
      this.context.fillRect(placeX - padding, placeY - textHeight, textPlaceWidth + (padding * 2), textHeight + padding);
      this.context.globalAlpha = 1;

      this.context.fillStyle = '#ffffff';
      this.context.font = textHeight + 'px Arial';
      this.context.textAlign = 'left';
      this.context.fillText(textPlace, placeX, placeY);
      this.context.textAlign = 'right';
      this.context.fillText(textDate, dateX, dateY);

      switch (imageIndex) {
        case 1: marketdateComment.image = (this.canvasEl.nativeElement as HTMLCanvasElement).toDataURL(); break;
        case 2: marketdateComment.image2 = (this.canvasEl.nativeElement as HTMLCanvasElement).toDataURL(); break;
        case 3: marketdateComment.image3 = (this.canvasEl.nativeElement as HTMLCanvasElement).toDataURL(); break;
      }
    };
    imageData.src = image;
  }

  getImageDatesFromMarketDateComment(marketDateComment: MarketDateComment): string[] {
    const result = [];

    if (marketDateComment.image !== '' && marketDateComment.image !== null) {
      if (marketDateComment.imageCreated !== '' && marketDateComment.imageCreated !== null) {
        result.push(marketDateComment.imageCreated);
      } else {
        result.push(marketDateComment.created);
      }
    }
    if (marketDateComment.image2 !== '' && marketDateComment.image2 !== null) {
      if (marketDateComment.image2Created !== '' && marketDateComment.image2Created !== null) {
        result.push(marketDateComment.image2Created);
      } else {
        result.push(marketDateComment.created);
      }
    }
    if (marketDateComment.image3 !== '' && marketDateComment.image3 !== null) {
      if (marketDateComment.image3Created !== '' && marketDateComment.image3Created !== null) {
        result.push(marketDateComment.image3Created);
      } else {
        result.push(marketDateComment.created);
      }
    }

    return result;
  }

  getImagesFromMarketAccountingEntry(expense: MarketAccountingEntry): any[] {
    const result = [];

    if (expense.image !== '' && expense.image !== null) {
      result.push('data:image/jpeg;base64,' + expense.image);
    }
    if (expense.image2 !== '' && expense.image2 !== null) {
      result.push('data:image/jpeg;base64,' + expense.image2);
    }
    if (expense.image3 !== '' && expense.image3 !== null) {
      result.push('data:image/jpeg;base64,' + expense.image3);
    }

    return result;
  }

  openPaymentModal(paymentModal, row) {
    setTimeout(() => {
      this.selectedRow = row;
      this.paymentModalRef = this.modalService.open(this.paymentModal, {size: 'lg'});
      this.paymentModalRef.result.then(close => {
        this.selectedRow = null;
      }, dismiss => {
        this.selectedRow = null;
      });
    }, 50);
  }

  rowClass = (row) => {
    let assortmentGreen = false;
    let assortmentExtended = false;
    let assortmentBoth = false;
    let assortmentNone = false;
    switch (this.getSalesunitAssortmentType(row.salesunit, true)) {
      case 'assortment':
        assortmentGreen = true;
        break;
      case 'assortmentExtended':
        assortmentExtended = true;
        break;
      case 'both':
        assortmentBoth = true;
        break;
      case 'none':
        assortmentNone = true;
        break;
      default:
        break;
    }
    return {
      'assortment-green': assortmentGreen,
      'assortment-extended': assortmentExtended,
      'assortment-both': assortmentBoth,
      'assortment-none': assortmentNone,
      'open-merchant-modifications': (row.merchantId && row.merchantModifications.length > 0)
    };
  }

  getSalesunitAssortmentType(salesunit: Salesunit, simplified = false) {
    let salesunitAssortmentType: 'assortment' | 'assortmentExtended' | 'both' | 'none';
    const typeFromKeys = this.assortmentService.assortmentTypeFromKeyStrings(salesunit.getAssortments());
    if (typeFromKeys === '67/1') {
      salesunitAssortmentType = 'assortment';
    }
    if (typeFromKeys === '67/2') {
      salesunitAssortmentType = 'assortmentExtended';
    }
    return salesunitAssortmentType;
  }

  onActivate(event: any) {
    if (event.type === 'click') {
      event.cellElement.blur();
    }
  }

  openModal(modal: any, options: NgbModalOptions) {
    this.modalRef = this.modalService.open(modal, options);
  }

  openMassSmsModal(recipientType: 'employees' | 'merchantContactPersons', weeks: number = 56, dev: boolean = false) {
    const date = new Date(this.marketDate.evasiveDate);

    if (recipientType === 'employees') {
      this.getMmContacts().subscribe((mmContacts: Array<Contact>) => {
        [this.marketAccounting.marketOverviewEntry.interimsMarketMaster1,
          this.marketAccounting.marketOverviewEntry.interimsMarketMaster2,
          this.marketAccounting.marketOverviewEntry.interimsMarketMaster3].forEach((interim: Contact) => {
          if (interim) {
            mmContacts.push(interim);
          }
        });
        this.modalRef = this.modalService.open(MassSmsComponent, {size: 'lg', backdrop: 'static', windowClass: 'xl'});
        this.modalRef.componentInstance.contacts = mmContacts;
        this.modalRef.componentInstance.recipientType = recipientType;
        this.modalRef.componentInstance.message = 'Betrifft: Wochenmarkt '
          + this.marketDate.marketday.keyword + ' - ' + date.toLocaleDateString();
      });
    } else if (recipientType === 'merchantContactPersons') {
      this.loadingOverlay = true;

      this.getAccountedMarketdateBoothsByMarketdate(weeks).then((marketdateBooths: Array<Booth>) => {
        this.loadingOverlay = false;
        const contactPersons: Array<Contact> = this.removeDuplicates(
          marketdateBooths
            .map((booth: Booth) => booth.contactPerson)
            .filter((contactPerson: Contact) => !!(contactPerson)),
            'id');
        this.modalRef = this.modalService.open(MassSmsComponent, {size: 'lg', backdrop: 'static', windowClass: 'xl'});
        this.modalRef.componentInstance.contacts = contactPersons;
        this.modalRef.componentInstance.recipientType = recipientType;
        this.modalRef.componentInstance.numberOfWeeks = weeks;
        this.modalRef.componentInstance.message = 'Betrifft: Wochenmarkt '
          + this.marketDate.marketday.keyword + ' - ' + date.toLocaleDateString();
      })
        .catch(error => {
          console.log('error getting lastMarketdateBooths', error);
          this.loadingOverlay = false;
        });

      // Solution with all subordinate contacts of present marketdatebooth.merchants
      // Promise.all(this.filteredMarketAccountingEntries.map(fmae => this.findSubordinateContacts(fmae.merchant)))
      //   .then(subordinateContacts => {
      //     this.loadingOverlay = false;
      //     const contacts = subordinateContacts.reduce((a, b) => a.concat(b));
      //     this.modalRef = this.modalService.open(MassSmsComponent, {size: 'lg', backdrop: 'static'});
      //     this.modalRef.componentInstance.contacts = contacts;
      //     // this.modalRef.componentInstance.predefinedContactSelection = this.filteredMarketAccountingEntries
      //     //  .filter(marketAccountingEntry => marketAccountingEntry.lastAccountContactPerson !== undefined)
      //     //  .map(marketAccountingEntry => marketAccountingEntry.lastAccountContactPerson);
      //     this.modalRef.componentInstance.recipientType = recipientType;
      //   }).catch((error) => {
      //     console.log('error finding subordinateContacts', error);
      //     this.loadingOverlay = false;
      // });
    }
  }

  getAccountedMarketdateBoothsByMarketdate(weeks: number) {
    return new Promise((resolve, reject) => {
      this.apiService.find<Booth>(Booth, (this.marketDate.canceled ? 'last-' : '') +
        'accounted-marketdate-booths-by-marketdate/' + this.marketDateId + '/' + weeks.toString())
        .subscribe(data => resolve(data), error => reject(error));
    });
  }

  findSubordinateContacts(merchant: Contact): Promise<Array<Contact>> {
    const subordinateContacts = [];
    return new Promise<Array<Contact>>((resolve, reject) => {
      this.apiService.find<Contact>(Contact, 'contacts/' + merchant.id + '/subordinate-contacts').subscribe(
        // tslint:disable-next-line:no-shadowed-variable
        subordinateContacts => {
          subordinateContacts = subordinateContacts.filter(subordinateContact =>
            subordinateContact.status !== ContactStatus.Deleted && subordinateContact.casFunction !== 'Büromitarbeiter');
          if (merchant.firstname && merchant.lastname) {
            subordinateContacts.push(merchant);
          }
          resolve(subordinateContacts);
        }, error => {
          reject(subordinateContacts);
        }
      );
    });
  }

  getMmContacts(): Observable<Array<Contact>> {
    return forkJoin(this.marketAccounting.marketMasters.map((mmsc) => (mmsc && mmsc.user) ? this.getContactByUserId(mmsc.user.id) : null));
  }

  marketHasMerchantModifications() {
    return Object.keys(this.merchantModifications).some(mId =>
      this.merchantModifications[mId] && this.merchantModifications[mId].length > 0);
  }

  saveMarketingFee(saveNew: boolean) {
    if (saveNew) {
      this.marketAccounting.marketingFee = this.marketingFeeTemp;
    } else {
      this.marketAccounting.marketingFee = null;
      this.marketingFeeTemp = null;
    }
    const requestBody = +this.marketAccounting.marketingFee;
    this.apiService.putRegular(requestBody,
      'backoffice/marketing-fee/' + this.marketAccounting.marketOverviewEntry.marketdateId).subscribe();
    this.modalRef.close();
  }

  confirmMarket() {
    this.loadingIndicator = true;
    const confirmObj = {
      total: (this.marketMasterAccountingsSum.boothTotalSum) ? this.marketMasterAccountingsSum.boothTotalSum : 0,
      expenses: (this.marketMasterAccountingsSum.expenseTotalSum) ? this.marketMasterAccountingsSum.expenseTotalSum : 0,
      payment: (this.marketMasterAccountingsSum.totalSum) ? this.marketMasterAccountingsSum.totalSum : 0,
      numberOfBooths: this.marketAccounting.marketAccountingEntries.filter(bomae => bomae.status === 'Completed').length
    };

    this.apiService.putRegular(confirmObj, 'backoffice/confirm-market/' + this.marketAccounting.marketOverviewEntry.marketdateId)
      .subscribe(marketAccounting => {
        this.marketAccounting = marketAccounting;
        this.principal.identity().then(user => {
          const marketDateStatus: MarketdateStatus = new MarketdateStatus();
          marketDateStatus.id = null;
          marketDateStatus.marketdate = this.marketDate;
          marketDateStatus.marketdayNumber = this.marketDate.marketdayNumber;
          marketDateStatus.status = MarketStatus.Confirmed;
          marketDateStatus.created = moment().format();
          marketDateStatus.updated = moment().format();
          marketDateStatus.updatedBy = user;
          marketDateStatus.comment = this.confirmMarketReason;
          this.apiService.postRegular(marketDateStatus, 'marketdate-statuses/')
            .subscribe(res => {
              this.loadingIndicator = false;
              this.modalRef.close();
              this.routingData.clearMarketOverviewEntries();
              this.router.navigate(['/open-accountings']);
            });
        });
      });
  }

  saveTempMarketMaster() {
    this.apiService.putRegular(this.tempInterimsMarketmasters, 'marketdate-interims-marketmaster/' + this.marketDateId)
      .subscribe(response => {
        this.marketAccounting.marketOverviewEntry.interimsMarketMaster1 = this.tempInterimsMarketmasters[0];
      });
  }

  saveMarketMasterStatus() {
    return new Promise((resolve, reject) => {

      for (let i = 0; i < 3; i++) {
        this.marketDate['mm' + (i + 1) + 'Status'] = this.marketMasterStatuses[i];
        console.log('Status: ' + (i + 1) + this.marketDate['mm' + (i + 1) + 'Status']);
      }

      this.apiService.putRegular(this.marketMasterStatuses, 'marketdate-marketmaster-status/' + this.marketDate.id)
        .subscribe(response => {
          console.log('SAVED statuses..');
          resolve(true);
        }, error => {
          console.log('AN ERROR OCCURED...');
          reject(false);
        });
    });
  }

  showInterimsSaveButton(): boolean {
    let result = false;

    for (let i = 0; i < 3; i++) {
      const tempInterim = this.tempInterimsMarketmasters[i];
      const interim = this.marketAccounting.marketOverviewEntry['interimsMarketMaster' + (i + 1)];

      if (tempInterim !== interim) {
        result = true;
      }
    }

    return result;
  }

  checkDate(date: string) {
    const marketAccountingDate = new Date(date);
    const today = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    const madTime = marketAccountingDate.getTime().toString().slice(0, -3);
    const todTime = today.getTime().toString().slice(0, -3);
    const result = madTime >= todTime;
    return result;
  }

  cancelMarket(cancel: boolean) {
    if (cancel) {
      this.principal.identity().then(user => {
        const marketDateStatus: MarketdateStatus = new MarketdateStatus();
        marketDateStatus.marketdate = this.marketDate;
        marketDateStatus.marketdayNumber = this.marketDate.marketdayNumber;
        marketDateStatus.status = this.cancelMarketStatus;
        marketDateStatus.created = moment().format();
        marketDateStatus.updated = moment().format();
        marketDateStatus.updatedBy = user;
        marketDateStatus.comment = this.cancelMarketReason;
        this.apiService.postRegular(marketDateStatus, 'marketdate-statuses/')
          .subscribe(res => {
            this.modalRef.close();
            this.routingData.clearMarketOverviewEntries();
            this.router.navigate(['/planning']);
          });
      });
    } else {
      this.cancelMarketStatus = null;
      this.cancelStatus.forEach(status => status.selected = false);
    }
    this.modalRef.close();
  }

  changeCancelStatus(cancelStatus) {
    if (cancelStatus) {
      this.cancelMarketStatus = (cancelStatus.selected) ? cancelStatus.value : null;
      this.cancelStatus.filter(status => status.value.toString() !== cancelStatus.value.toString())[0].selected = false;
    } else {
      this.cancelMarketStatus = null;
    }
  }

  marketdateInPast() {
    const todayDate = new Date().setHours(0, 0, 0, 0);
    const mdDate = new Date(this.marketDate.evasiveDate).setHours(0, 0, 0, 0);
    return mdDate < todayDate;
  }

  manualSettlementMarket(confirmManualSettlement: boolean) {
    if (confirmManualSettlement) {
      this.principal.identity().then(user => {
        const marketDateStatus: MarketdateStatus = new MarketdateStatus();
        marketDateStatus.marketdate = this.marketDate;
        marketDateStatus.marketdayNumber = this.marketDate.marketdayNumber;
        marketDateStatus.status = MarketStatus.Manual;
        marketDateStatus.created = moment().format();
        marketDateStatus.updated = moment().format();
        marketDateStatus.updatedBy = user;
        marketDateStatus.comment = this.manualSettlementMarketReason;
        this.apiService.postRegular(marketDateStatus, 'marketdate-statuses/')
          .subscribe(res => {
            this.modalRef.close();
            this.routingData.clearMarketOverviewEntries();
            this.router.navigate(['/' + this.parentUrl]);
          });
      });
    }
    this.modalRef.close();
  }

  marketHasNegativeComments(marketDateComments) {
    return marketDateComments.filter(comment => comment.commentType.toString() === 'Warning').length > 0;
  }

  getChecklistItems(statusOpened: boolean) {
    return this.marketAccounting.marketOverviewEntry.marketDateComments
      .filter(comment => comment.status === ((statusOpened) ? MarketStatus.Opened.toString() : MarketStatus.Closed.toString()))
      .sort(function(a, b) {
        const commentA = a.comment.toUpperCase();
        const commentB = b.comment.toUpperCase();
        if (commentA < commentB) {
          return -1;
        }
        if (commentA > commentB) {
          return 1;
        }
        return 0;
      });
  }

  checkMarketdateChecklistItems() {
    const checklistItemsWithoutStatus = this.marketAccounting.marketOverviewEntry.marketDateComments.filter(item => item.status === null);

    if (checklistItemsWithoutStatus.length > 0) {

      let openedDate = null;
      let closedDate = null;

      const checkPromise = new Promise((resolve, reject) => {
        this.marketAccounting.marketOverviewEntry.marketDateComments.forEach((item, index) => {
          if (!openedDate) {
            openedDate = item.created;
          } else if (openedDate > item.created) {
            openedDate = item.created;
          }

          if (!closedDate) {
            closedDate = item.created;
          } else if (closedDate < item.created) {
            closedDate = item.created;
          }

          if (index === this.marketAccounting.marketOverviewEntry.marketDateComments.length - 1) {
            resolve();
          }

        });
      }).then(() => {
        this.marketAccounting.marketOverviewEntry.marketDateComments.forEach((item, index) => {
          if (item.created === openedDate) {
            item.status = MarketStatus.Opened.toString();
          } else if (item.created === closedDate) {
            item.status = MarketStatus.Closed.toString();
          }
        });
      });
    }

  }

  getContactByUserId(userId: number): Observable<Contact> {
    return this.apiService.findOne<Contact>(Contact, 'contact-by-user/' + userId);
  }

  getContractIntervals(id: number): Promise<ContractInterval[]> {
    return new Promise((resolve, reject) => {
      this.apiService.get('contract-intervals-by-contract/' + id)
        .subscribe((data) => {
          const result: ContractInterval[] = JSON.parse(data._body);
          this.selectedMerchantContractIntervals = result;
          resolve(result);
        }, error => { reject(error); });
    });
  }

  getBoothsLastContact() {
    this.merchantLastContact = null;
    return new Promise((resolve, reject) => {
      if (!this.selectedMerchant || !this.selectedMerchant.merchantId) { resolve(); }
      this.apiService.findOne(Contact,
        `marketdate-booths-last-contact-person/${this.marketDate.marketday.id}/${this.selectedMerchant.merchantId}`)
        .subscribe((data) => {
          this.merchantLastContact = data;
          resolve(data);
        }, error => { resolve(); });
    });
  }

  getBoothsByEnergyType(energyType: string) {
    return this.marketAccounting.marketAccountingEntries.filter(marketAccountingEntry =>
      marketAccountingEntry.status === 'Completed'
      && (
        (marketAccountingEntry.contractType === 'Standard')
          ? ((marketAccountingEntry.energyPriceTypeDivergent !== null && marketAccountingEntry.energyPriceTypeDivergent !== 'Null')
            ? marketAccountingEntry.energyPriceTypeDivergent === energyType
            : (marketAccountingEntry.ctEnergyType !== null && marketAccountingEntry.ctEnergyType === energyType))
          : marketAccountingEntry.energyPriceType === energyType && marketAccountingEntry.energyPriceType !== null)
    );
  }

  getWeightetEnergyUnits(): number {
    return this.getBoothsByEnergyType( 'Low').length +
      this.getBoothsByEnergyType( 'Normal').length * 2 +
      this.getBoothsByEnergyType( 'Special').length * 3;
  }

  onSelect(event: any, modal) {
    this.loadingOverlay = true;
    this.zoom = 16;
    this.selectedMerchant = event.selected[0];
    this.newAccountingView = true;
    this.selectedMerchantContractHistory = null;

    const promises = [
      this.getDiscounts(),
      this.getVisits(),
      this.getSalesunitAssortmentChecks(this.selectedMerchant.salesunit.id),
      this.getBoothsLastContact()
    ];

    if (this.selectedMerchant.contractType === 'Standard') {
      // Deactivated, because too many requests are made at once.
      // promises.push(this.getContractHistory(this.selectedMerchant, new Date(this.marketDate.evasiveDate)));
      this.getContractIntervals(this.selectedMerchant.contract.id);
    }

    Promise.all(promises)
      .then(() => {
        this.openModal(modal, {size: 'lg', windowClass: 'modal-1200'});
        this.loadingOverlay = false;
      }, error => {
        console.log('error getting open payments or salesunits: ', error);
        this.loadingOverlay = false;
      });
  }

  merchantMapReady(googleMap: GoogleMap) {
    const latLng = {
      lat: parseFloat(this.selectedMerchant.geoEntity.latitude.toString()),
      lng: parseFloat(this.selectedMerchant.geoEntity.longitude.toString())
    };
    googleMap.setOptions({
      center: latLng,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      draggable: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      zoom: 18
    });
    const merchantMarker = new google.maps.Marker({
      position: latLng,
      map: googleMap,
      icon: './assets/img/map-pin.png'
    });
    merchantMarker.setMap(googleMap);
  }

  getSqmSum(bomae: BackofficeMarketAccountingEntry) {
    if (bomae.contractType === 'Standard') {

      let sqmContractBooth = bomae.ctBoothWidth * bomae.ctBoothDepth;
      let sqmContractBoothAdditional = bomae.ctBoothWidthAdditional * bomae.ctBoothDepthAdditional;

      if (this.winter) {
        if (bomae.ctUseWinterSize && bomae.ctBoothWidthWinter > 0 && bomae.ctBoothDepthWinter > 0) {
          sqmContractBooth = Math.ceil(bomae.ctBoothWidthWinter * bomae.ctBoothDepthWinter);
        }
        if (bomae.ctUseAddtitionalWinterSize && bomae.ctBoothWidthWinterAdditional !== null
          && bomae.ctBoothDepthWinterAdditional !== null) {
          sqmContractBoothAdditional = Math.ceil(bomae.ctBoothWidthWinterAdditional * bomae.ctBoothDepthWinterAdditional);
        }
      }


      const sqmAdditonalDaily = bomae.widthAdditionalDaily * bomae.depthAdditionalDaily;
      let total = Math.ceil((sqmContractBooth + sqmContractBoothAdditional)
        + ((sqmAdditonalDaily > sqmContractBoothAdditional) ? (sqmAdditonalDaily - sqmContractBoothAdditional) : 0));
      const sqmSalesunit = (!this.winter || bomae.suBoothWidthWinter == null || bomae.suBoothWidthWinter === 0)
        ? Math.ceil(bomae.suBoothWidth * bomae.suBoothDepth) : Math.ceil(bomae.suBoothWidthWinter * bomae.suBoothDepthWinter);

      if (sqmSalesunit > total) {
        total = sqmSalesunit;
      }

      return total;
    } else {
      const sqmSalesunit = Math.ceil(bomae.width * bomae.depth);
      const sqmAdditional = Math.ceil(bomae.widthAdditional * bomae.depthAdditional);

      return Math.ceil(sqmSalesunit + sqmAdditional);
    }
  }

  getSumOfSettlement(bomae: BackofficeMarketAccountingEntry) {
    if (bomae.contractType === 'Standard') {
      let sumCost = 0;

      const costs = {
        sqmCost: bomae.sqmCost,
        energyCost: (bomae.energyPriceTypeDivergent && bomae.energyPriceTypeDivergent.toString() !== 'Null' &&
          bomae.energyPriceTypeDivergent.toString() !== 'None') ? (bomae.energyPrice) : 0,
        serviceCleaningCost: bomae.priceCleaning,
        serviceSanitaryCost: bomae.priceSanitary,
        serviceParkingCost: bomae.priceParking,
        serviceVariable: bomae.priceVariable,
        marketingCost: bomae.marketingFee,
        openPayments: (bomae.openPaymentSettled) ? bomae.openPaymentSettled : 0,
        postalReceiptFee: bomae.postalReceiptFee || 0,
      };

      for (const costsKey in costs) {
        if (costs[costsKey]) {
          sumCost += parseFloat(costs[costsKey]);
        }
      }
      return sumCost;
    } else {
      let sumCost = 0;

      const costs = {
        sqmCost: bomae.sqmCost,
        baseCost: bomae.sqmCostIncludingBase - bomae.sqmCost,
        additionalFeeCashCost: bomae.sqmCostIncludingAdditionalFeeCash - bomae.sqmCost,
        energyCost: bomae.energyPrice,
        serviceCleaningCost: bomae.priceCleaning,
        serviceSanitaryCost: bomae.priceSanitary,
        serviceParkingCost: bomae.priceParking,
        serviceVariable: bomae.priceVariable,
        marketingCost: bomae.marketingFee,
        permMarketingCost: bomae.permanentMarketingFee,
        openPayments: (bomae.openPaymentSettled) ? bomae.openPaymentSettled : 0,
        marketwebsiteBaseFee: bomae.marketwebsiteBaseFee || 0,
        marketwebsiteAdvertisingFee: bomae.marketwebsiteAdvertisingFee || 0,
        postalReceiptFee: bomae.postalReceiptFee || 0,
      };

      for (const costsKey in costs) {
        if (costs[costsKey]) {
          sumCost += parseFloat(costs[costsKey]);
        }
      }

      if (bomae.contractType === 'None' && (bomae.discount && bomae.discount > 0) && (bomae.discountPercentage
        && bomae.discountPercentage > 0)) {
        sumCost -= bomae.discount;
        // if (bomae.discountPercentage === 1) {
        //   sumCost += 1;
        // }
      }

      return sumCost;
    }
  }

  formatPercentage(value: number) {
    return this.mathCeil(value * 100);
  }

  isMinBoothFeeActive(bomae: BackofficeMarketAccountingEntry): boolean {
    let minBoothFeeActive = false;
    if (!bomae.discount || bomae.discountType === 'Periodic') {
      const width = (bomae.width) ? parseFloat(bomae.width.toString().replace(',', '.')) : 0;
      const depth = (bomae.depth) ? parseFloat(bomae.depth.toString().replace(',', '.')) : 0;
      const sqm = width * depth;
      const sqmCeil = Math.ceil(sqm);

      const widthAdditional = (bomae.widthAdditional) ?
        parseFloat(bomae.widthAdditional.toString().replace(',', '.')) : 0;
      const depthAdditional = (bomae.depthAdditional) ?
        parseFloat(bomae.depthAdditional.toString().replace(',', '.')) : 0;
      const sqmAdditional = widthAdditional * depthAdditional;
      const sqmAdditionalCeil = Math.ceil(sqmAdditional);

      const cost = (sqmCeil + sqmAdditionalCeil) * this.boothFeeSqmPrice;
      if (cost < this.boothFee.minBoothFee && bomae.contractType === 'None') {
        minBoothFeeActive = true;
      }
    }
    return minBoothFeeActive;
  }

  getSqmCostWithoutMinBoothFee(bomae: BackofficeMarketAccountingEntry) {
    const width = (bomae.width) ? parseFloat(bomae.width.toString().replace(',', '.')) : 0;
    const depth = (bomae.depth) ? parseFloat(bomae.depth.toString().replace(',', '.')) : 0;
    const sqm = width * depth;
    const sqmCeil = Math.ceil(sqm);

    const widthAdditional = (bomae.widthAdditional) ?
      parseFloat(bomae.widthAdditional.toString().replace(',', '.')) : 0;
    const depthAdditional = (bomae.depthAdditional) ?
      parseFloat(bomae.depthAdditional.toString().replace(',', '.')) : 0;
    const sqmAdditional = widthAdditional * depthAdditional;
    const sqmAdditionalCeil = Math.ceil(sqmAdditional);

    const cost = (sqmCeil + sqmAdditionalCeil) * this.selectedMerchant.pricePerUnit;

    return cost;
  }

  getTotalKwh() {
    let result = 0;
    this.marketAccounting.electricMeterInfo.forEach((electricMeter, index) => {
      if ((this.marketAccounting.marketOverviewEntry.status === 'Closed' ||
        this.marketAccounting.marketOverviewEntry.status === 'Confirmed') &&
        !electricMeter.notAccessibleBefore && !electricMeter.notAccessibleAfter) {
        result += (electricMeter.readingAfter.value - electricMeter.readingBefore.value) * electricMeter.factor;
      }
    });
    return result;
  }

  saveMarketdateMeterreading(save: boolean) {
    if (save && this.marketdateMeterreadingToEdit) {
      this.marketdateMeterreadingToEdit.value = this.marketdateMeterreadingToEditValue;
      this.marketdateMeterreadingToEdit.notAccessible = false;
      this.marketdateMeterreadingToEdit.timestamp = new Date();
      this.marketdateMeterreadingToEdit.updated = new Date();
      if (!this.marketdateMeterreadingToEdit || !this.marketdateMeterreadingToEdit.id) {
        this.marketdateMeterreadingToEdit.origin = Origin.BackOfficeNew;
      } else {
        this.marketdateMeterreadingToEdit.origin = Origin.BackOfficeUpdate;
      }
      // If id does not exist, use different api path
      if (!this.marketdateMeterreadingToEdit.id) {
        this.apiService.postRegular(this.marketdateMeterreadingToEdit, '/backoffice/marketdate-meterreadings').subscribe(res => {
          this.marketdateMeterreadingToEdit = null;
          this.modalRef.close();
          if (!this.selectedElectricmeter.readingBefore.id && !this.selectedElectricmeter.readingAfter.id) {
            window.location.reload(false);
          }
        }, (err) => console.log(err));
      } else {
        this.apiService.putRegular(this.marketdateMeterreadingToEdit, '/marketdate-meterreadings').subscribe(res => {
          this.marketdateMeterreadingToEdit = null;
          this.modalRef.close();
        });
      }
    } else {
      this.marketdateMeterreadingToEdit = null;
      this.modalRef.close();
    }
  }

  /**
   * Creates new electricMeter reading
   */
  createMarketdateMeterreading(electricmeterInfo, meterreading: MarketdateMeterreading, type: any) {
    if (!meterreading.id) {
      meterreading.timestampType = type;
      meterreading.marketdate = {id: this.marketDate.id};
      meterreading.created = new Date();
      meterreading.updatedBy = {id: Number.parseInt(this.account.id)} as Contact;
      if (!meterreading.electricmeter) {
        meterreading.electricmeter = {id: electricmeterInfo.electricmeterId};
      }
    }
    this.marketdateMeterreadingToEditValue = meterreading.value ? meterreading.value : 0;
    this.marketdateMeterreadingToEdit = meterreading;
    this.selectedElectricmeter = electricmeterInfo;

    this.openModal(this.editMarketdateMeterreadingModal, {size: 'sm', windowClass: 'm', backdrop: 'static'});
  }

  createNewMessage(newMessageModal) {
    // Edit v5.9.0 Allow multiple announcements
    /* if (!this.messages.some(message => message.createdBy.id === this.account['contact'].id &&
      (message.marketdate && message.marketdate.id === this.marketDate.id))) {*/
      this.newMessage = {
        id: null,
        created: new Date(),
        updated: new Date(),
        marketdate: this.marketDate,
        marketday: this.marketDate.marketday,
        createdBy: null,
        content: '',
        messageType: MessageType.Announcement
      };
    // }
    this.openModal(newMessageModal, {size: 'sm', windowClass: 'm'});
  }

  editMessage(messageModal, message) {
    this.messageToEdit = {... message};
    this.openModal(messageModal, {size: 'sm', windowClass: 'm'});
  }

  saveMessage(save: boolean, messageToSave: Message) {
    if (save) {
      if (messageToSave.id) {
        this.apiService.putRegular(messageToSave, 'messages/')
          .subscribe(res => {
            this.getMessages(this.marketDate, null, true);
          });
      } else {
        this.apiService.postRegular(messageToSave, 'messages/')
          .subscribe(res => {
            this.getMessages(this.marketDate, null, true);
          });
      }
    }
    this.messageToEdit = null;
    this.newMessage = null;
    this.modalRef.close();
  }

  getOpenPaymentsByStatusAndMarketdateAndMerchant(status: string, marketdate: Marketdate, merchantId: number) {
    if (marketdate && status && this.openPayments) {
      return this.openPayments.filter(op => op.status === status && op.marketdate.id === marketdate.id && op.merchant.id === merchantId);
    } else if (status && this.openPayments) {
      return this.openPayments.filter(op => op.status === status);
    } else {
      return [];
    }
  }

  getOpenPaymentsByStatusAndMarketdayAndMerchant(status: string, marketdayId: number, merchantId: number): Array<OpenPayment> {
    if (marketdayId && status && this.openPayments) {
      return this.openPayments.filter(op => op.status === status && op.marketday.id === marketdayId && op.merchant.id === merchantId);
    } else if (status && this.openPayments) {
      return this.openPayments.filter(op => op.status === status);
    } else {
      return [];
    }
  }

  clearOpenPayment(clear: boolean) {
    if (clear) {
      this.principal.identity().then(user => {
        this.openPaymentToClear.status = 'Cleared';
        this.openPaymentToClear.updatedBy = user.contact;
        this.openPaymentToClear.branchComment = this.tempOpenPaymentComment;
        this.apiService.put(this.openPaymentToClear, 'open-payments/' + this.selectedMerchant.marketdateBoothId).subscribe(
          openPaymentResult => {
            this.openPaymentToClear = null;
            this.tempOpenPaymentComment = null;
          }
        );
      });
    }
  }

  markMessagesAsRead() {
    this.apiService.get('mark-messages-read-by-marketday/' + this.marketDate.marketday.id)
      .subscribe(res => {
        this.messages.map(messages => messages.read = true);
        this.messagesCounters[0] = this.messagesCounters[1];
      }, error => {
        console.log('error marking messages as read', error);
      });
  }

  markDepositsAsRead() {
    this.apiService.get('mark-deposits-read-by-marketday/' + this.marketDate.marketday.id)
      .subscribe(res => {
        this.deposits.map(deposit => deposit.read = true);
        this.depositCounters[0] = this.depositCounters[1];
      }, error => {
        console.log('error marking deposits as read', error);
      });
  }

  markCompletedStatus(row: BackofficeMarketAccountingEntry): boolean {
    let result = false;

    if (row) {
      if (row.contractType === 'Standard') {
        // contract
        result =
          // different booth size
          (this.winter && row.ctUseWinterSize && (row.salesunit.boothWidthWinter !== null && row.salesunit.boothDepthWinter !== null)
            ? (row.ctBoothWidthWinter !== row.salesunit.boothWidthWinter || row.ctBoothDepthWinter !== row.salesunit.boothDepthWinter)
            : (row.ctBoothWidth !== row.salesunit.boothWidth || row.ctBoothDepth !== row.salesunit.boothDepth)) ||
           // different energyType
          (row.energyPriceTypeDivergent
            && row.energyPriceTypeDivergent.toString() !== 'Null'
            && (!this.winter && row.energyPriceTypeDivergent !== row.ctEnergyType ||
              (this.winter && row.ctEnergyTypeWinter && row.energyPriceTypeDivergent !== row.ctEnergyTypeWinter))) ||
          // open payment
          (row.noPaymentReceived || row.partialPaymentReceived);
      } else {
        // non-contract
        result =
          // different booth size
          (row.width !== ((!this.winter || (this.winter && this.isNullOr0(row.salesunit.boothWidthWinter)))
            ? row.salesunit.boothWidth : row.salesunit.boothWidthWinter)
            || row.depth !== ((!this.winter || (this.winter && this.isNullOr0(row.salesunit.boothDepthWinter)))
              ? row.salesunit.boothDepth : row.salesunit.boothDepthWinter)) ||
          // different energyType
          (row.energyPriceType.toString() !==
            ((!this.winter || (this.winter && this.isNullOr0(row.salesunit.energyTypeWinter)))
              ? row.salesunit.energyType : row.salesunit.energyTypeWinter).toString()) ||
          // open payment
          (row.noPaymentReceived || row.partialPaymentReceived) ||
          // discount
          ((row.discount !== null || row.discount > 0) && row.discountPercentage > 0 && row.discountType !== null
            && (row.discountType === 'Single' || (row.discountType === 'Periodic' && this.getSqmSum(row) > 20)));
      }
    }

    return result;
  }

  openMap(geoEntity: GeoEntity) {
    this.mapData = {
      geoEntity: geoEntity,
      addressLine: ''
    };
    this.getGeoAddressLine(geoEntity);
    this.zoom = 16;

    setTimeout(() => {
      this.mapModalRef = this.modalService.open(this.mapModal, {size: 'lg'});

      this.mapModalRef.result.then(close => {
        this.mapData = null;
      }, dismiss => {
        this.mapData = null;
      });
    }, 50);
  }

  marketMapReady(googleMap: GoogleMap) {
    const bounds = new google.maps.LatLngBounds();
    const latLngMarketMaster = {
      lat: parseFloat(this.mapData.geoEntity.latitude.toString()),
      lng: parseFloat(this.mapData.geoEntity.longitude.toString())
    };
    const latLngMarket = {
      lat: parseFloat(this.marketDate.marketday.marketplace.latitude.toString()),
      lng: parseFloat(this.marketDate.marketday.marketplace.longitude.toString())
    };
    const mapOptions: MapOptions = {
      center: latLngMarketMaster,
      zoom: 18,
      gestureHandling: 'cooperative',
      streetViewControl: false,
      zoomControl: true,
      zoomControlOptions: {
        position: ControlPosition.RIGHT_BOTTOM,
        style: ZoomControlStyle.DEFAULT
      }
    };
    googleMap.setOptions(mapOptions);
    const markerMarketMaster = new google.maps.Marker({
      position: latLngMarketMaster,
      map: googleMap,
      // icon: './assets/img/map-pin.png'
    });
    const markerMarket = new google.maps.Marker({
      position: latLngMarket,
      map: googleMap,
      // icon: './assets/img/market.png'
    });
    [markerMarketMaster, markerMarket].forEach((marker) => {
      bounds.extend(marker.position);
      marker.setMap(googleMap);
    });
    googleMap.fitBounds(bounds);
  }

  getGeoAddressLine(geoEntity: GeoEntity): void {
    this.osmNominatimService.reverseGeocoding('jsonv2', geoEntity.latitude, geoEntity.longitude)
      .subscribe(nominatimData => {
        let addressLine = '';
        console.log('nominatimData', nominatimData);
        if (nominatimData.address) {
          addressLine = ['road', 'house_number', 'postcode', 'city']
            .map(addressItem => nominatimData.address[addressItem])
            .join(' ');
        }
        this.mapData.addressLine = addressLine;
      }, error => {
        this.mapData.addressLine = '';
      });
  }

  parseToFLoat(val: any): number {
    return parseFloat(val.toString());
  }

  increaseZoom() {
    this.zoom  = Math.min(this.zoom + .25, 20);
  }

  decreaseZoom() {
    this.zoom  = Math.max(this.zoom - .25, 1);
  }

  saveCompensation(save: boolean) {
    this.modalRef.close();
  }

  isNullOr0(value: any) {
    return (value === null || value === 0 || value === 'Null');
  }

  getWeatherJson(weather: Weather) {
    return JSON.parse(weather.weatherJson);
  }

  getWindDirection(degree) {
    const val = Math.floor((degree / 22.5) + 0.5);
    const arr = ['N', 'NNO', 'NO', 'ONO', 'O', 'OSO', 'SO', 'SSO', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'];
    return arr[(val % 16)];
  }

  moveToPlanning() {
    this.marketDate.status = MarketdateStatusEnum.Unopened;
    this.apiService.putRegular(this.marketDate, 'marketdates').subscribe(res => {
      console.log('response moving to planung', res);
    });
  }

  findContactTempsByMarketdate(marketdateId: number): Promise<any> {
    return new Promise<any>(resolve => {
      this.apiService.get( 'backoffice/merchant-modifications-by-marketdate/' + marketdateId).subscribe(res => {
        this.merchantModifications = res.json();
        resolve();
      }, error => {
        this.merchantModifications = {};
        resolve(error);
      });
    });
  }

  goToBaseData() {
    const date = this.marketDate.evasiveDate.split('T')[0];
    const marketdayId = this.marketDate.marketday.id;
    this.router.navigate(['base-data'], {queryParams: {'useLastMarketDetail': true, 'marketdayId': marketdayId, 'date': date}}).then();
  }

  goToCompanyBaseData(merchantId: number) {
    if (merchantId) {
      this.router.navigate(['base-data', 'company', merchantId], {queryParams: {'useLastMarketDetail': true}}).then();
    }
  }

  getSalesunitWidthModification() {
    return this.selectedMerchant.salesunitBefore
      && ((!this.winter || (this.winter && this.isNullOr0(this.selectedMerchant.suBoothWidthWinter)))
        ? this.selectedMerchant.suBoothWidth !== this.selectedMerchant.salesunitBefore.boothWidth
        : this.selectedMerchant.suBoothWidthWinter !== this.selectedMerchant.salesunitBefore.boothWidthWinter);
  }

  getSalesunitWidthModificationTemp() {
    if (this.selectedMerchant.contractType === 'Standard') {
      return this.selectedMerchant.tempAreaChange
        && ((!this.winter || !this.selectedMerchant.ctUseWinterSize
          || (this.winter && this.isNullOr0(this.selectedMerchant.suBoothWidthWinter)))
          ? this.selectedMerchant.suBoothWidth !== this.selectedMerchant.ctBoothWidth
          : this.selectedMerchant.suBoothWidthWinter !== this.selectedMerchant.ctBoothWidthWinter);
    } else {
      return (!this.winter || (this.winter && this.isNullOr0(this.selectedMerchant.suBoothWidthWinter)))
        ? this.selectedMerchant.suBoothWidth !== this.selectedMerchant.width
        : this.selectedMerchant.suBoothWidthWinter !== this.selectedMerchant.width;
    }
  }

  getSalesunitDepthModification() {
    return this.selectedMerchant.salesunitBefore
      && ((!this.winter || (this.winter && this.isNullOr0(this.selectedMerchant.suBoothDepthWinter)))
        ? this.selectedMerchant.suBoothDepth !== this.selectedMerchant.salesunitBefore.boothDepth
        : this.selectedMerchant.suBoothDepthWinter !== this.selectedMerchant.salesunitBefore.boothDepthWinter);
  }

  getSalesunitDepthModificationTemp() {
    if (this.selectedMerchant.contractType === 'Standard') {
      return this.selectedMerchant.tempAreaChange
        && ((!this.winter || !this.selectedMerchant.ctUseWinterSize
          || (this.winter && this.isNullOr0(this.selectedMerchant.suBoothDepthWinter)))
          ? this.selectedMerchant.suBoothDepth !== this.selectedMerchant.ctBoothDepth
          : this.selectedMerchant.suBoothDepthWinter !== this.selectedMerchant.ctBoothDepthWinter);
    } else {
      return (!this.winter || (this.winter && this.isNullOr0(this.selectedMerchant.suBoothDepthWinter)))
        ? this.selectedMerchant.suBoothDepth !== this.selectedMerchant.depth
        : this.selectedMerchant.suBoothDepthWinter !== this.selectedMerchant.depth;
    }
  }

  getSalesunitSizeModification() {
    return this.selectedMerchant.salesunitBefore && !this.selectedMerchant.tempAreaChange
      && (this.getSalesunitWidthModification() || this.getSalesunitDepthModification());
  }

  getSalesunitSizeModificationEffect(): 'temp' | 'permanent' | 'none' {
    return (!this.getSalesunitSizeModification())
      ? ((this.getSalesunitWidthModificationTemp() || this.getSalesunitDepthModificationTemp()) ? 'temp' : 'none')
      : 'permanent';
  }

  getSalesunitEnergyModification() {
    return this.selectedMerchant.salesunitBefore
      && (((!this.winter || (this.winter &&
        (this.isNullOr0(this.selectedMerchant.suEnergyTypeWinter) || this.selectedMerchant.suEnergyTypeWinter === 'Null')))
        ? this.selectedMerchant.suEnergyType !== this.selectedMerchant.salesunitBefore.energyType.toString()
        : this.selectedMerchant.suEnergyTypeWinter !== this.selectedMerchant.salesunitBefore.energyTypeWinter.toString()));
  }

  getSalesunitEnergyModificationTemp() {
    return ((!this.winter || (this.winter &&
      (this.isNullOr0(this.selectedMerchant.suEnergyTypeWinter) || this.selectedMerchant.suEnergyTypeWinter === 'Null')))
      ? this.selectedMerchant.energyPriceType.toString() !== this.selectedMerchant.suEnergyType.toString()
      : this.selectedMerchant.energyPriceType.toString() !== this.selectedMerchant.suEnergyTypeWinter.toString());
  }

  getSalesunitEnergyModificationEffect(): 'temp' | 'permanent' | 'none' {
    return (!this.getSalesunitEnergyModification())
      ? (this.getSalesunitEnergyModificationTemp() ? 'temp' : 'none')
      : 'permanent';
  }


  print(printSectionId) {
    const printContents = document.getElementById(printSectionId).innerHTML;
    const stylesHtml = this.getTagsHtml('style');
    const linksHtml = this.getTagsHtml('link');
    let title = '';

    if (printSectionId === 'printMerchantDetail') {
      title = 'Beschickerabrechnung - ' + this.selectedMerchant.contractType
          .replace('Standard', 'Beschicker mit Dauerzulassung')
          .replace('None', 'Beschicker mit Tageszulassung')
        + ' ' + this.selectedMerchant.companyName
        + ' (Beschicker-Nr. ' + this.selectedMerchant.merchantNumber + ')';
    }

    if (printSectionId === 'printMarketDetail') {
      title = 'Marktabrechnung - ' + this.marketAccounting.title + ' - ' + moment(this.marketAccounting.date).format('DD.MM.YYYY');
    }

    const popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
    <html>
      <head>
        <title>${title}</title>
        ${linksHtml}
        ${stylesHtml}
        <style type="text/css" media="print">
          @page{ size: A4 landscape;
            margin: 5mm;
            }

        </style>
      </head>
      <body onload="window.print(); setTimeout(function(){  window.close(); }, 300);">
        ${printContents}
      </body>
    </html>
    `
    );
    popupWin.document.close();
  }

  private getTagsHtml(tagName: keyof HTMLElementTagNameMap): string {
    const htmlStr: string[] = [];
    const elements = document.getElementsByTagName(tagName);
    for (let i = 0; i < elements.length; i++) {
      htmlStr.push(elements[i].outerHTML);
    }

    return htmlStr.join('\r\n');
  }

  openMarketDetailPrintModal(modal) {
    this.openModal(modal, {size: 'lg', windowClass: 'modal-1200'});
  }

  someOpenedMAE() {
    return this.filteredMarketAccountingEntries.some(bomae => bomae.status === 'None');
  }

  mathCeil(val): number {
    return Math.ceil(val);
  }

  monthNumberToString(monthNumber) {
    let result = monthNumber;
    switch (monthNumber) {
      case 1:
        result = 'Januar';
        break;
      case 2:
        result = 'Februar';
        break;
      case 3:
        result = 'März';
        break;
      case 4:
        result = 'April';
        break;
      case 5:
        result = 'Mai';
        break;
      case 6:
        result = 'Juni';
        break;
      case 7:
        result = 'Juli';
        break;
      case 8:
        result = 'August';
        break;
      case 9:
        result = 'September';
        break;
      case 10:
        result = 'Oktober';
        break;
      case 11:
        result = 'November';
        break;
      case 12:
        result = 'Dezember';
        break;
      default:
        break;
    }
    return result;
  }

  getMMNumber(displayName: string) {
    let mmNumber = '';
    this.marketMasterAccountings.forEach((mma) => {
      if (mma.mmDisplayName === displayName) {
        mmNumber = mma.mmNumber;
      }
    });
    return mmNumber;
  }

  getPriceCategoryTitle(priceCategory: string): string {
    return this.marketDate.marketday['priceCategoryTitle' + priceCategory];
  }

  loadDepositReceiptImg(message: Message) {

  }

  showDepositReceipt(message: Message) {
    const imageData = new Image();
    imageData.onload = () => {
      const textDate = this.datePipe.transform(message.created, 'dd.MM.yyyy')
        + ' - '
        + this.datePipe.transform(message.created, 'shortTime') + ' Uhr';
      const textPlace = 'ML ' + message.createdBy.merchantNumber;

      const resFactor = Math.ceil(imageData.width / 1000);
      const textHeight = 20 * resFactor;

      this.context.font = textHeight + 'px Arial';
      const textDateWidth = this.context.measureText(textDate).width;
      const textPlaceWidth = this.context.measureText(textPlace).width;

      const padding = textHeight;

      (this.canvasEl.nativeElement as HTMLCanvasElement).width = imageData.width;
      (this.canvasEl.nativeElement as HTMLCanvasElement).height = imageData.height;

      this.context.drawImage(imageData, 0, 0);

      this.context.textBaseline = 'middle';

      const dateX = imageData.width - (padding * 2);
      const dateY = imageData.height - (padding * 2);

      const placeX = padding * 2;
      const placeY = imageData.height - (padding * 2);

      this.context.fillStyle = '#000000';
      this.context.globalAlpha = 0.5;
      this.context.fillRect(dateX - textDateWidth - padding, dateY - textHeight, textDateWidth + (padding * 2), textHeight + padding);
      this.context.fillRect(placeX - padding, placeY - textHeight, textPlaceWidth + (padding * 2), textHeight + padding);
      this.context.globalAlpha = 1;

      this.context.fillStyle = '#ffffff';
      this.context.font = textHeight + 'px Arial';
      this.context.textAlign = 'left';
      this.context.fillText(textPlace, placeX, placeY);
      this.context.textAlign = 'right';
      this.context.fillText(textDate, dateX, dateY);

      this.showImageCarousel(message.content, [(this.canvasEl.nativeElement as HTMLCanvasElement).toDataURL()], 0, ['']);
    };

    if (!message.image && message.imageUploaded) {
      this.apiService.getImage(['messages', message.id, 'image'].join('/')).subscribe((image: Blob) => {
        const fileReader = new FileReader();
        fileReader.onload = () => imageData.src = fileReader.result;
        fileReader.readAsDataURL(new File([image], 'image', {type: 'image/jpeg'}));
      });
    } else {
      imageData.src = 'data:image/png;base64,' + message.image;
    }
  }

  getRecalculatedSqm(bomae: BackofficeMarketAccountingEntry): number {
    let total = bomae.suBoothWidth * bomae.suBoothDepth;
    if (this.winter) {
      if (bomae.suBoothDepthWinter !== null && bomae.suBoothDepthWinter > 0
        && bomae.suBoothWidthWinter !== null && bomae.suBoothWidthWinter > 0
      ) {
        total = bomae.suBoothDepthWinter * bomae.suBoothDepthWinter;
      }
    }
    total = Math.ceil(total);
    const widthAdditionalDaily = Math.ceil((bomae.widthAdditionalDaily && bomae.depthAdditionalDaily) ?
        bomae.widthAdditionalDaily * bomae.depthAdditionalDaily : 0);
    total += widthAdditionalDaily;

    const contractSqm = this.getAlreadyPaidSqm(bomae);
    let result = total - contractSqm;
    if (result < 0) {
      result = 0;
    }
    return result;
  }

  getAlreadyPaidSqm(bomae: BackofficeMarketAccountingEntry): number {
    let sqmTotal = 0;
    let sqm = 0;
    let sqmAdditional = 0;

    sqm = (this.winter && bomae.ctUseWinterSize && bomae.ctBoothWidthWinter !== null)
      ? bomae.ctBoothWidthWinter * bomae.ctBoothDepthWinter
      : bomae.ctBoothWidth * bomae.ctBoothDepth;

    sqmAdditional = (this.winter && bomae.ctUseAddtitionalWinterSize && bomae.ctBoothWidthWinter !== null)
      ? bomae.ctBoothWidthWinterAdditional * bomae.ctBoothDepthWinterAdditional
      : bomae.ctBoothWidthAdditional * bomae.ctBoothDepthAdditional;

    sqmTotal = Math.ceil(sqm) + Math.ceil(sqmAdditional);

    return sqmTotal;
  }

  readingValid(value): boolean {
    return isNumber(value);
  }

  openedMarketdateInPast(): boolean {
    const rowDate = new Date(this.marketDate.evasiveDate);
    const nowDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0 , 0);
    return (this.marketDate.status.toString() === 'Opened' && rowDate < nowDate);
  }

  emitInputClickEvent(elementId) {
    document.getElementById(elementId).click();
  }

  changeListener($event, item, imgNo): void {
    if ($event.target && $event.target.files && $event.target.files.length > 0) {
      item[imgNo + '_created'] = new Date();
      this.readThis($event.target, item, imgNo);
    }
  }

  readThis(inputValue: any, item: any, imgNo: string): void {
    const file: File = inputValue.files[0];
    const myReader: FileReader = new FileReader();

    switch (imgNo) {
      case 'image':
        item.imageFile = inputValue.files[0];
        break;
      case 'image2':
        item.image2File = inputValue.files[0];
        break;
      case 'image3':
        item.image3File = inputValue.files[0];
        break;
    }

    myReader.onloadend = (e) => {
      const imageString = myReader.result;
      const imageData = imageString.split(',');
      switch (imgNo) {
        case 'image':
          item.image = imageData[1];
          item.imageCreated = new Date();
          const previewImageElement = document.getElementById('previewImage-' + item.name + '-1');
          previewImageElement['src'] = 'data:image/jpeg;base64,' + item.image;
          break;
        case 'image2':
          item.image2 = imageData[1];
          item.image2Created = new Date();
          const previewImage2Element = document.getElementById('previewImage-' + item.name + '-2');
          previewImage2Element['src'] = 'data:image/jpeg;base64,' + item.image2;
          break;
        case 'image3':
          item.image3 = imageData[1];
          item.image3Created = new Date();
          const previewImage3Element = document.getElementById('previewImage-' + item.name + '-3');
          previewImage3Element['src'] = 'data:image/jpeg;base64,' + item.image3;
          break;
      }
    };
    myReader.readAsDataURL(file);
  }

  openCloseMarketModal() {
    if (!this.canCloseMarket()) {
      this.modalService.open(this.cannotCloseMarketModal, {size: 'lg', windowClass: ''});
      return;
    }
    this.resetCloseMarketChecklist();
    this.loadingOverlay = true;
    this.findElectricMeters(this.marketDate.marketday.marketplace.id).then(() => {
      this.modalRef = this.modalService.open(this.closeMarketModal, {size: 'lg', windowClass: '', backdrop: 'static'});
      this.loadingOverlay = false;
    }).catch(e => {
      this.loadingOverlay = false;
    });
  }

  /**
   * Checks if the market is allowed to get closed or not.
   * Returns false, if any market accounting entry with standard contract has a status of none
   */
  canCloseMarket(): boolean {
    const result = this.filteredMarketAccountingEntries.filter((item) => item.contractType === 'Standard' && item.status === 'None');
    return result.length <= 0;
  }

  resetCloseMarketChecklist() {
    this.checklistClose = [
      {
        title: 'Sind die Stromkästen unbeschädigt und abgeschlossen?',
        checked: null,
        checkRequired: true,
        name: 'metersClosed',
        comment: '',
        image: '',
        imageCreated: '',
        image2: '',
        image2Created: '',
        image3: '',
        image3Created: '',
        imageFile: null,
        image2File: null,
        image3File: null,
        instructionText: 'Bitte ein Foto der Situation anfertigen',
        descriptionText: 'Warum konnten die Stromkästen nicht geschlossen werden?'
      },
      {
        title: 'Ist der Marktplatz sauber?',
        checked: null,
        checkRequired: true,
        name: 'marketClean',
        comment: '',
        image: '',
        imageCreated: '',
        image2: '',
        image2Created: '',
        image3: '',
        image3Created: '',
        imageFile: null,
        image2File: null,
        image3File: null,
        instructionText: 'Bitte ein Übersichtsfoto und ein Foto der Verschmutzung anfertigen',
        descriptionText: 'Hinweise auf verursachenden Beschicker'
      },
      {
        title: 'Ist die Oberfläche des Marktplatz unbeschädigt?',
        checked: null,
        checkRequired: true,
        name: 'skinClean',
        comment: '',
        image: '',
        imageCreated: '',
        image2: '',
        image2Created: '',
        image3: '',
        image3Created: '',
        imageFile: null,
        image2File: null,
        image3File: null,
        instructionText: 'Bitte ein Übersichtsfoto und ein Foto des Schadens anfertigen',
        descriptionText: 'Hinweise auf verursachenden Beschicker'
      },
      {
        title: 'Ist der Markt unfallfrei verlaufen?',
        checked: null,
        checkRequired: true,
        name: 'accidentFree',
        comment: '',
        image: '',
        imageCreated: '',
        image2: '',
        image2Created: '',
        image3: '',
        image3Created: '',
        imageFile: null,
        image2File: null,
        image3File: null,
        instructionText: 'Bitte ein Foto der Situation anfertigen',
        descriptionText: 'Bitte erfassen Sie nötige Hinweise'
      }
    ];
    this.showPreviewImage = [];
    this.marketdateMeterreading = [];
    this.checklistClose.forEach(value => this.showPreviewImage[value.name] = [false, false, false]);
  }

  changeChecklistCloseItem(event, checklistItem) {
    checklistItem.checked = event;
    checklistItem.image = checklistItem.image2 = checklistItem.image3 =
      checklistItem.imageCreated = checklistItem.image2Created = checklistItem.image3Created = '';
  }

  closeMarketDisabled(): boolean {
    const checklistInvalid = this.checklistClose
      .some(item => item.checked === null || (item.checked === false && item.image === ''));
    const meterreadingsInvalid = this.marketdateMeterreading
      .some(reading => (reading.notAccessible === false || reading.notAccessible === undefined)
        && (!reading.value || !isNumber(reading.value)
          || parseFloat(reading.value.toString().replace(',', '.')) < 0));
    const selectMMInvalid = (document.getElementById('closingMarketMaster') as HTMLSelectElement).value === '-1' ? true : false;
    return checklistInvalid || meterreadingsInvalid || selectMMInvalid;
  }

  findElectricMeters(marketPlaceId: number) {
    return new Promise((resolve, reject) => {
      this.apiService.find<Electricmeter>(Electricmeter, 'marketplaces/' + marketPlaceId + '/electricmeters')
        .subscribe( electricMeters => {
          this.electricMeters = electricMeters.sort((a: Electricmeter, b: Electricmeter) => {
            if (a.location === b.location) {
              return ((a.electricmeterNumber) ? a.electricmeterNumber : '')
                .localeCompare((b.electricmeterNumber) ? b.electricmeterNumber : '');
            } else {
              return ((a.location) ? a.location : '').localeCompare((b.location) ? b.location : '');
            }
          });
          this.electricMeters.forEach(electricmeter => {
            const reading: MarketdateMeterreading = new MarketdateMeterreading();
            reading.electricmeter = deserialize(Electricmeter, electricmeter);
            reading.marketdate = deserialize(Marketdate, this.marketDate);
            reading.timestampType = TimestampType.After;
            this.marketdateMeterreading.push(reading);
          });
          resolve();
        }, error => reject());
    });
  }

  calculatePowerConsumption(valueNew, valueOld) {
    if (isUndefined(valueOld) || valueOld === '' || valueOld == null) {
      valueOld = 0.00;
    }
    if (isUndefined(valueNew) || valueNew === '' || valueNew == null) {
      return null;
    }
    const valueNewFloat = parseFloat(valueNew.toString().replace(',', '.'));
    const valueOldFloat = parseFloat(valueOld.toString().replace(',', '.'));
    const powerConsumption = valueNewFloat - valueOldFloat;

    const factor = Math.pow(10, 2);
    const tempNumber = powerConsumption * factor;
    const roundedTempNumber = Math.round(tempNumber);

    return roundedTempNumber / factor;
  }

  getTotalPowerConsumption(getNegativeFlag: boolean = false) {
    let total = 0;
    let allReadingsValid = true;
    this.marketdateMeterreading.forEach(meterreading => {
      const valNew = meterreading.value;
      const valOld = meterreading.electricmeter.lastValue;
      let meterreadingPowerConsumption = this.calculatePowerConsumption(valNew, valOld);
      if (meterreading.electricmeter.factor !== 0 && meterreading.electricmeter.factor !== 1 &&
        meterreading.electricmeter.factor !== null) {
        meterreadingPowerConsumption = meterreadingPowerConsumption * meterreading.electricmeter.factor;
      }
      if (meterreadingPowerConsumption >= 0) {
        total += meterreadingPowerConsumption;
      } else {
        allReadingsValid = false;
      }
    });
    if (getNegativeFlag) {
      return (total >= 0 && allReadingsValid);
    } else {
      return (total >= 0 && allReadingsValid) ? this.numberPipe.transform(total, '1.2-2').toString() + ' kWh' :
        'Ermittlung nicht möglich, da mindestens ein negatives Ergebnis vorhanden ist.';
    }
  }

  changeReading(reading: MarketdateMeterreading) {
    reading.timestamp = moment().format();
    reading.created = moment().format();
  }

  changeReadingAccessibility(reading) {
    reading.notAccessible = !reading.notAccessible;
    if (reading.notAccessible) {
      reading.value = (reading.electricmeter.lastValue !== null) ? reading.electricmeter.lastValue : 0;
    } else {
      reading.value = 0;
    }
    this.changeReading(reading);
  }

  closeMarket() {
    const e = (document.getElementById('closingMarketMaster') as HTMLSelectElement);
    const mmId = parseInt(e.value, 10);
    if (mmId <= 0) { return; }
    const mmUser = this.possibleTempMarketMasters.find((user: User) => user.id === mmId).user;

    this.loadingOverlay = true;
    this.principal.identity().then(user => {

    this.marketdateMeterreading = this.marketdateMeterreading
      .map(reading => {
        reading.value = parseFloat(reading.value.toString().replace(',', '.'));
        reading.marketdate = this.marketDate;
        return reading;
      });

      const marketDateStatus: MarketdateStatus = new MarketdateStatus();
      marketDateStatus.marketdate = this.marketDate;
      marketDateStatus.marketdayNumber = this.marketDate.marketdayNumber;
      marketDateStatus.status = MarketStatus.Closed;
      marketDateStatus.created = moment().format();
      marketDateStatus.updated = moment().format();
      marketDateStatus.updatedBy = mmUser;
      marketDateStatus.updatedByBranchmaster = user;
      marketDateStatus.geoEntity = null;

      let requests: Array<Observable<any>> = [];
      requests = requests
        .concat(
          this.marketdateMeterreading.map(reading =>
            this.apiService.postRegular(reading, 'marketdate-meterreadings/')
              .map(res => deserialize<MarketdateMeterreading>(MarketdateMeterreading, res.json()))
          )
        )
        .concat(
          this.checklistClose.map(item => {
            const marketdateComment = new MarketDateComment();
            marketdateComment.marketdate = this.marketDate;
            marketdateComment.updated = moment().format();
            marketdateComment.created = moment().format();
            marketdateComment.updatedBy = user.contact;
            marketdateComment.status = 'Closed';
            marketdateComment.commentType = (item.checked) ? CommentType.Info : CommentType.Warning;
            marketdateComment.comment = item.title;
            marketdateComment.image = (item.checked) ? '' : (NEW_IMAGE_UPLOAD) ? null : item.image;
            marketdateComment.image2 = (item.checked) ? '' : (NEW_IMAGE_UPLOAD) ? null : item.image2;
            marketdateComment.image3 = (item.checked) ? '' : (NEW_IMAGE_UPLOAD) ? null : item.image3;
            marketdateComment.imageCreated = (item.checked) ? '' : item.imageCreated;
            marketdateComment.image2Created = (item.checked) ? '' : item.image2Created;
            marketdateComment.image3Created = (item.checked) ? '' : item.image3Created;
            marketdateComment.userComment = (item.checked) ? '' : ((item.comment) ? item.comment : '');
            return this.apiService.postRegular(marketdateComment, 'marketdate-comments/')
              .map(res => deserialize<MarketDateComment>(MarketDateComment, res.json()));
          })
        );
      requests.push(
        this.apiService.postRegular(marketDateStatus, 'marketdate-statuses/')
          .map(res => deserialize<MarketdateStatus>(MarketdateStatus, res.json()))
      );

      forkJoin(requests).subscribe((results: Array<any>) => {
        console.log('success clsing market!', results);

        const ready = () => {
          if (this.modalRef) {
            this.modalRef.close();
          }
          this.loadingOverlay = false;
          this.ngOnInit();
        };

        if (NEW_IMAGE_UPLOAD && this.checklistClose.some(item => !item.checked)) {
          this.loadingOverlay = false;
          // tslint:disable-next-line:no-shadowed-variable
          const marketdateComments: Array<MarketDateComment> = results.filter((e: any) => e instanceof MarketDateComment);
          const uploadData = marketdateComments.map((mdc: MarketDateComment) => {
            const item = this.checklistClose.find(c => c.title === mdc.comment);
            return [item.imageFile, item.image2File, item.image3File]
              .filter(f => !!(f))
              .map((file: File, index: number) => ({
                file,
                url: ['marketdate-comments', mdc.id, 'image', index + 1].join('/')
              }));
          }).reduce((acc, val) => acc.concat(val), []);

          this.fileService.uploadMultipleFiles(uploadData, 'Checklisten', true, true)
            .then((postImagesResult: any) => {
              ready();
            }, postImagesError => {
              console.log('(market-change-status.component) Error post marketdate-comments images', postImagesError);
              ready();
            });

        } else {
          ready();
        }
      }, error => {
        console.log('error closing market!', error);
        this.loadingOverlay = false;
      });
    });
  }

  saveMarketMasterChanges() {
    let workingCount = 0;
    for (let i = 0; i < 3; i++) {
      if (this.marketMasterStatuses[i] === MarketmasterStatusEnum.Work) {
        workingCount++;
      }
    }
    if (workingCount === 0 && this.tempInterimsMarketmasters[0] == null) {
      this.openModal(this.errorMarketMasterStatusModal, {size: 'lg', windowClass: ''});
    } else {
      this.saveMarketMasterStatus().then(
        (success) => {
          if (success) {
            this.saveTempMarketMaster();
            this.openModal(this.successMarketMasterStatusModal, {size: 'lg', windowClass: ''});
            this.hasMarketMasterChanges = false;
          } else {
            console.log('Error saving Market Master status');
          }
        }
      );
    }
  }

  setMarketMasterStatuses() {
    for (let i = 0; i < 3; i++) {
      const statusBefore = this.marketDate['mm' + (i + 1) + 'Status'];
      this.marketMasterStatuses[i] = statusBefore;
      if (statusBefore == null) {
        if (this.marketDate.marketday['mm' + (i + 1) + 'Percentage'] > 0) {
          this.marketMasterStatuses[i] = MarketmasterStatusEnum.Work;
        } else {
          this.marketMasterStatuses[i] = MarketmasterStatusEnum.NoPay;
        }
      }
    }
  }

  getStatusByMMId(mmId: String) {
    for (let i = 0; i < 3; i++) {
      if (this.marketDate.marketday['marketMaster' + (i + 1)]) {
        if (mmId === this.marketDate.marketday['marketMaster' + (i + 1)].id) {
          return this.marketDate['mm' + (i + 1) + 'Status'];
        }
      }
    }
    return null;
  }

  getPositionByMMId(mmId: String) {
    for (let i = 0; i < 3; i++) {
      if (this.marketDate.marketday['marketMaster' + (i + 1)]) {
        if (mmId === this.marketDate.marketday['marketMaster' + (i + 1)].id) {
          return i;
        }
      }
    }
    return 4;
  }

  marketdateCommentImageClicked(marketDateComment: MarketDateComment, index: number): void {
    if (marketDateComment.image !== '') {
      if (!this.marketdateCommentImageSelectionMode) {
        // open image
        this.showImageCarousel(marketDateComment.comment, this.getImagesFromMarketDateComment(marketDateComment), index,
          this.getImageDatesFromMarketDateComment(marketDateComment));
      } else {
        // image selection

        let indexToImageNo: 'image' | 'image2' | 'image3';
        switch (index) {
          case 0: indexToImageNo = 'image'; break;
          case 1: indexToImageNo = 'image2'; break;
          case 2: indexToImageNo = 'image3'; break;
          default: break;
        }

        if (this.imageIsSelected(marketDateComment, index)) {
          this.selectedMarketdateCommentsImages.find(e => e.id === marketDateComment.id).images =
            this.selectedMarketdateCommentsImages.find(e => e.id === marketDateComment.id).images
              .filter(i => i.id !== indexToImageNo);

          if (this.selectedMarketdateCommentsImages.find(e => e.id === marketDateComment.id).images.length === 0) {
            this.selectedMarketdateCommentsImages = this.selectedMarketdateCommentsImages.filter(e => e.id !== marketDateComment.id);
          }
        } else {
          const marketdateCommentImage: MarketDateCommentImage = {
            id: indexToImageNo, base64: this.getImagesFromMarketDateComment(marketDateComment)[index]
          };

          if (!this.selectedMarketdateCommentsImages.some(e => e.id === marketDateComment.id)) {
            const marketrdateCommentImages: MarketDateCommentImages = { id: marketDateComment.id, images: [] };
            this.selectedMarketdateCommentsImages.push(marketrdateCommentImages);
          }
          this.selectedMarketdateCommentsImages.find(e => e.id === marketDateComment.id).images
            .push(marketdateCommentImage);
        }

      }
    }
  }

  imageIsSelected(marketDateComment: MarketDateComment, index: number): boolean {
    return this.selectedMarketdateCommentsImages.some(e => e.id === marketDateComment.id)
      && this.selectedMarketdateCommentsImages.find(e => e.id === marketDateComment.id).images
        .some(i => i.base64 === this.getImagesFromMarketDateComment(marketDateComment)[index]);
  }

  marketdateCommentImagesSelected(): boolean {
    return this.selectedMarketdateCommentsImages && this.selectedMarketdateCommentsImages.length > 0
      && this.selectedMarketdateCommentsImages.some(e => e.images && e.images.length > 0);
  }

  resetMerchantSearch() {
    // Reset Search
    this.merchantSearchContact = null;
    this.selectedSalesunit = null;
    this.searchInputMerchant = '';
  }


  openEmailComposer(mailBody?: string, mailSubject?: string, attachments?: MarketDateCommentImages): void {
    this.marketdateCommentImageSelectionMode = false;
    this.modalRef = this.modalService.open(MailComposerComponent, {size: 'lg', backdrop: 'static'});
    this.modalRef.componentInstance.marketdateCommentsImages = attachments ? [attachments] : this.selectedMarketdateCommentsImages;
    this.modalRef.componentInstance.mailSubject = mailSubject ? mailSubject : '';
    this.modalRef.componentInstance.mailBody = mailBody ? mailBody : '';
    this.modalRef.componentInstance.marketdayNumber = this.marketDate.marketdayNumber;
    this.modalRef.componentInstance.marketdayKeyword = this.marketDate.marketday.keyword;
    this.selectedMarketdateCommentsImages = [];
  }

  loadMerchantContact() {
    this.isMerchantPresent = false;
    this.selectedSalesunit = new Salesunit();
    return new Promise((resolve, reject) =>  {
      this.apiService.find<Contact>(Contact, /contacts-by-merchant-number/ + this.searchInputMerchant).subscribe(
        (response) => {
          if (!response) {
            resolve();
          } else {
            const filteredResponse = response.filter(contact => contact.casIsCompany);
            if (filteredResponse && filteredResponse.length > 0) {
              this.merchantSearchContact = filteredResponse[0];
              this.loadSalesunit(this.merchantSearchContact.id);
            }
            resolve();
          }
        }
      );
    });
  }

  confirmMerchantSearch() {
    // Create new booth based on search
    const booth = new Booth();
    booth.merchant = this.merchantSearchContact;
    booth.marketdate = this.marketDate;
    booth.salesunit = this.selectedSalesunit;
    booth.contractType = ContractType.None;
    booth.addedManually = true;

    this.resetMerchantSearch();

    // Post data
    this.apiService.postRegular(booth, 'marketdate-booths')
      .subscribe((result) => {
          this.openModal(this.confirmMerchantSearchModal, {});
          this.findContactTempsByMarketdate(this.marketDateId).then(() => this.load(this.marketDateId));
        },
        (error) => {
          this.addMerchantStatusError = error;
          console.warn(error);
          this.openModal(this.confirmMerchantSearchModal, {});
        });
  }

  loadSalesunit(merchantId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.apiService.find<Salesunit>(Salesunit, 'contacts/' + merchantId + '/salesunits').subscribe(
        (salesunits) => {
          // Sort salesunits by number
          salesunits.sort((a, b) => {
            if (a.salesunitNumber > b.salesunitNumber) {
              return 1;
            } else if (a.salesunitNumber === b.salesunitNumber) {
              return 0;
            } else {
              return -1;
            }
          });
          this.checkIsMerchantPresent();
          this.merchantSalesunits = salesunits;
          resolve();
        }
      );
    });
  }

  changeSalesunit(salesunit: Salesunit) {
    this.selectedSalesunit = salesunit;
    this.checkIsMerchantPresent();
  }

  checkIsMerchantPresent() {
    if (this.merchantSearchContact && this.selectedSalesunit) {
      if (this.marketAccounting.marketAccountingEntries.some(item => item.merchantId === this.merchantSearchContact.id)
        && this.marketAccounting.marketAccountingEntries.some(item => item.salesunit.id === this.selectedSalesunit.id)) {
        this.isMerchantPresent = true;
      } else {
        this.isMerchantPresent = false;
      }
    } else {
      this.isMerchantPresent = false;
    }
  }

  getConfirmationDisabledReason(): string {
    if (this.trainingSystem) {
      return 'Nur im Live-System verfügbar!';
    }
    if (
      this.apiStatus.marketAccounting === ApiStatus.NotLoaded || this.apiStatus.marketAccounting === ApiStatus.Loading
      || this.apiStatus.marketMasterAccountings === ApiStatus.NotLoaded || this.apiStatus.marketMasterAccountings === ApiStatus.Loading
    ) {
      return 'Bitte warten, Daten laden noch.';
    }
    if (this.marketHasMerchantModifications()) {
      return 'Es sind noch offene Stammdatenänderungen vorhanden!';
    }
    if (this.hasMessagesWithoutAction()) {
      return 'Es sind noch Markttagebuch-Einträge ohne Aktion vorhanden!';
    }
    return null;
  }

  /**
   * Checks if the current marketDate evasive date is in the past and its status unopened
   */
  isMarketUnopenedPast(): boolean {
    return this.marketDate.evasiveDate < new Date().toISOString() && this.marketDate.status === MarketdateStatusEnum.Unopened;
  }

  /**
   * Checks if a given variable is empty (null, undefined, '') or not.
   */
  hasValue(value: any): boolean {
    if (value === null) { return false; }
    if (value === undefined) { return false; }
    return value !== '';
  }

  getPriceVariableTitle(priceVariable): string {
    return priceVariable > 0 ? 'Gebühr Zahlart' : priceVariable < 0 ? 'Rabatt Zahlart' : 'Gebühr/ Rabatt Zahlart';
  }

}



// WEBPACK FOOTER //
// ./src/app/markets/components/market-detail/market-detail.component.ts